<!-- 发布记录列表 -->
<template>
  <Layout>
    <div class="back-view">
      <div
        style="
          justify-content: center;
          align-items: center;
          display: flex;
          flex-direction: column;
          padding-left: 20px;
        "
      >
        <div class="top-view">
          <div class="top-view-search" style="height: 30px !important">
            <div
              style="
                margin-right: 12px;
                color: #3a3a3c;
                font-size: 14px;
                font-weight: bold;
              "
            >
              搜索:
            </div>
            <el-input
              v-model="searchName"
              placeholder="请输入接龙名称"
              style="width: 220px; margin-right: 10px"
              clearable
              fontSize="13px"
            ></el-input>
            <!-- <div style="margin-right: 10px;color:#3A3A3C;font-size:14px;font-weight:bold">接龙类型:</div>-->
            <el-button
              type="primary"
              style="
                width: 100px;
                margin-right: 20px;
                position: relative;
                background-color: #1877ff;
                height: 30px;
                line-height: 7px;
                border-color: #1877ff;
              "
              @click="handleSearch"
              >搜索</el-button
            >
            <el-select
              v-model="activityType"
              placeholder="接龙类型"
              clearable
              style="width: 160px; margin-right: 10px"
              @change="activityBigTypeChange()"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!--<div style="margin-right: 10px;color:#3A3A3C;font-size:14px;font-weight:bold">接龙状态:</div> -->
            <!-- <el-select
              v-model="activeState"
              placeholder="接龙状态"
              clearable
              style="width: 160px; margin-right: 10px"
              @change="statusOptionsChange($event)"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
            <el-select
              v-model="activeStateName"
              placeholder="接龙状态"
              style="width: 160px; margin-right: 12px"
              @change="statusOptionsChange($event)"
              clearable
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <div style="margin-right: 10px;color:#3A3A3C;font-size:14px;font-weight:bold">发布时间:</div>-->

            <div style="min-width: 160px; display: flex">
              <el-select
                v-model="timeRangeName"
                placeholder="发布时间"
                style="width: 160px; margin-right: 12px"
                @change="handleTimeFilterChange"
                clearable
              >
                <el-option label="全部时间" value="全部"></el-option>
                <el-option label="近一个月" value="近一个月"></el-option>
                <el-option label="近三个月" value="近三个月"></el-option>
                <el-option label="近六个月" value="近六个月"></el-option>
                <el-option label="近一年" value="近一年"></el-option>
                <el-option label="自定义时间" value="自定义"></el-option>
              </el-select>
              <!-- 仅自定义时间时显示时间选择器 -->
              <el-date-picker
                v-if="showCustomTimePicker"
                v-model="customTimeRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width: 320px; margin-right: 12px"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                @change="handleCustomTimeChange"
              ></el-date-picker>
            </div>
            <el-select
              v-model="sortType"
              placeholder="排序"
              clearable
              style="width: 160px; margin-right: 12px"
              @change="sortTypeChange()"
            >
              <el-option
                v-for="item in timeoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="type-view">
        <div>
          <template v-if="!batchEditMode">
            <el-tag
              v-for="item in items"
              :key="item.label"
              :effect="activeTag === item.value ? 'dark' : 'plain'"
              @click="handleTagClick(item.value)"
              style="
                cursor: pointer;
                height: 30px;
                line-height: 30px;
                width: 112px;
                font-size: 13px;
                text-align: center;
                margin-right: 10px;
                color: #1877ff;
                border-color: #1877ff;
              "
              :style="{
                color: item.value == activeTag ? '#fff' : '#1877ff',
                backgroundColor: item.value == activeTag ? '#1877ff' : '#fff',
              }"
            >
              {{ item.label }}
            </el-tag>
          </template>

          <!-- 批量编辑模式下显示移动和删除按钮 -->
          <template v-if="batchEditMode">
            <el-button
              type="primary"
              size="small"
              style="margin-left: 10px"
              @click="batchMove"
              >移动</el-button
            >
            <el-button
              type="danger"
              plain
              size="small"
              style="margin-left: 5px"
              @click="batchDelete"
              >删除</el-button
            >
            <el-button
              plain
              size="small"
              style="margin-left: 10px"
              @click="batchEditMode = false"
              >取消</el-button
            >
          </template>
        </div>

        <div class="createFloderClass" @click="showCreateFolderDialog = true">
          + 新建文件夹
        </div>
      </div>

      <!-- style="max-width: 1080px" -->

      <div class="list-back-view">
        <el-table
          :header-cell-style="headerCellStyle"
          :data="tableData"
          :row-key="(row) => row.id || row.folderId"
          v-if="tableData"
          @selection-change="handleSelectionChange"
          @row-click="handleRowClick"
        >
          <template slot="empty">
            <div style="margin-top: 50px">
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/tjfx-nodata.svg"
                alt=""
              />
            </div>
            <span>暂无数据</span>
          </template>
          <!-- 多选框列，批量编辑时显示 -->
          <el-table-column
            type="selection"
            width="55"
            v-if="batchEditMode && tableData.some((item) => !item.is_folder)"
            :selectable="selectableRow"
          ></el-table-column>
          <el-table-column prop="activity_type_name" width="80" align="left">
            <template slot="header">
              <span> 类型 </span>
            </template>
            <template slot-scope="scope">
              <!-- 文件夹不显示类型 -->
              <template v-if="scope.row.is_folder">
                <img
                  src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/lsyJL/folderIcon.png"
                  alt="文件夹"
                  style="
                    width: 18px;
                    height: 18px;
                    margin-right: 5px;
                    margin-left: 20px;
                  "
                />
              </template>
              <template v-else>
                <div
                  :class="isStatisticsOnly(scope.row) ? 'bmclass' : 'sfclass'"
                  style="text-align: center"
                  v-show="scope.row.activity_type == 101"
                >
                  {{ isStatisticsOnly(scope.row) ? "报名" : "收费报名" }}
                </div>
                <div
                  class="jlclass"
                  v-show="
                    scope.row.activity_type != 109 &&
                    scope.row.activity_type != 110 &&
                    scope.row.activity_type != 104 &&
                    scope.row.activity_type != 101 &&
                    scope.row.activity_type != 303 &&
                    scope.row.activity_big_type == 1
                  "
                >
                  通用场景
                </div>
                <div
                  class="dkclass"
                  style="text-align: center"
                  v-show="
                    scope.row.activity_type == 109 ||
                    scope.row.activity_type == 110 ||
                    scope.row.activity_type == 104
                  "
                >
                  打卡签到
                </div>
                <div
                  class="tzclass"
                  style="text-align: center"
                  v-show="scope.row.activity_type == 201"
                >
                  通知公告
                </div>
                <div
                  class="hyclass"
                  style="text-align: center"
                  v-show="scope.row.activity_type == 303"
                >
                  信息查询
                </div>
              </template>
            </template>
          </el-table-column>

          <el-table-column
            prop="name"
            label="标题"
            min-width="160"
            align="left"
          >
            <template slot-scope="scope">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  cursor: pointer;
                  text-align: left;
                "
              >
                <!-- 文件夹显示文件夹图标和名称 -->
                <template v-if="scope.row.is_folder">
                  <p
                    style="
                      text-align: left;
                      margin-bottom: 0;
                      color: #323233;
                      font-weight: 600;
                    "
                  >
                    {{ scope.row.folderName }}
                    <span style="color: #999"
                      >({{ scope.row.activityCount }})</span
                    >
                  </p>
                </template>
                <!-- 普通活动 -->
                <template v-else>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.name"
                    placement="top"
                    :open-delay="1000"
                  >
                    <p
                      style="
                        text-align: left;
                        margin-bottom: 0;
                        color: #1877ff;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                      "
                      class="hover-underline"
                      @click.stop="nameClick(scope.row)"
                    >
                      <!-- 红包标识 -->
                      <img
                        v-if="scope.row.hasRedPacket == 2"
                        src="https://ossfastmake.xlkapp.com/qrCode/tupian/1766556738098.svg"
                        style="width: 17px; height: 17px; margin-right: 6px"
                        alt="红包"
                      />
                      {{ scope.row.name }}
                    </p>
                  </el-tooltip>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="80"
            align="center"
            label="状态"
            prop="active_state"
          >
            <template slot-scope="scope">
              <div v-if="recordType != 4 && recordType != 3">
                <div
                  :class="{
                    nobegin: scope.row.active_state == 1,
                    alreadyend: scope.row.active_state == 2,
                    going: scope.row.active_state == 3,
                  }"
                  v-if="scope.row.is_draft == 0 || recordType == 5"
                >
                  <p v-if="scope.row.active_state == 1">未开始</p>
                  <p v-if="scope.row.active_state == 2">已结束</p>
                  <p v-if="scope.row.active_state == 3">进行中</p>
                </div>
                <div
                  class="cgclass"
                  v-if="scope.row.is_draft == 1 && scope.row.is_draft"
                >
                  <p>草稿</p>
                </div>
              </div>

              <div
                :class="{
                  nobegin: scope.row.active_state == 1,
                  alreadyend: scope.row.active_state == 2,
                  going: scope.row.active_state == 3,
                }"
                v-else-if="recordType == 4 || recordType == 3"
              >
                <div v-if="scope.row.active_state == 1">未开始</div>
                <div v-if="scope.row.active_state == 2">已结束</div>
                <div v-if="scope.row.active_state == 3">进行中</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="begin_time"
            label="创建时间"
            align="center"
          ></el-table-column>
          <el-table-column prop="end_time" label="结束时间" align="center">
            <template slot-scope="scope">
              {{
                scope.row.end_time == "2099-12-31 23:59:59"
                  ? "永久有效"
                  : scope.row.end_time
              }}
            </template>
          </el-table-column>

          <el-table-column
            v-if="recordType != 3"
            fixed="right"
            label="操作"
            width="230"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                v-if="recordType != 4 && recordType != 3"
                type="text"
                size="small"
                style="margin-right: 10px; color: #1877ff; font-size: 14px"
                @click.stop="viewItem(scope.row)"
                ><span v-if="!scope.row.is_folder"
                  >{{ scope.row.sign_num }} </span
                >查看</el-button
              >
              <template v-if="scope.row.is_draft == 1 && scope.row.is_draft">
                <el-button
                  icon="el-icon-edit"
                  style="margin-right: 10px; color: #1877ff; font-size: 14px"
                  type="text"
                  size="small"
                  @click.stop="dropdownSet(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  style="margin-right: 10px; color: #1877ff; font-size: 14px"
                  type="text"
                  size="small"
                  icon="el-icon-delete"
                  @click.stop="dropdownDel(scope.row)"
                  >删除</el-button
                >
              </template>
              <template v-else>
                <el-button
                  v-if="scope.row.is_forward === 0"
                  icon="el-icon-share"
                  style="margin-right: 10px; color: #1877ff; font-size: 14px"
                  type="text"
                  size="small"
                  @click.stop="shareClick(scope.row)"
                  >分享{{ scope.index }}</el-button
                >
                <el-dropdown
                  v-if="recordType !== 3"
                  trigger="click"
                  @mousedown.stop
                  @click.stop
                >
                  <el-button
                    type="text"
                    icon="el-icon-setting"
                    style="color: #1877ff; font-size: 14px"
                    class="el-dropdown-link"
                    @click.stop
                  >
                    管理
                  </el-button>
                  <el-dropdown-menu slot="dropdown" @mousedown.stop @click.stop>
                    <!-- 文件夹操作 -->
                    <template v-if="scope.row.is_folder">
                      <el-dropdown-item
                        icon="el-icon-edit-outline"
                        @click.native="renameFolder(scope.row)"
                        >重命名</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-edit"
                        @click.native="batchEditFolder(scope.row)"
                        >批量移动、删除</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-service"
                        @click.native="openCustomerServiceDialog"
                        >联系客服</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-delete"
                        @click.native="deleteFolder(scope.row)"
                        >删除文件夹</el-dropdown-item
                      >
                    </template>
                    <!-- 我的发布 -->
                    <!-- 草稿-->
                    <template
                      v-else-if="scope.row.is_draft == 1 && scope.row.is_draft"
                    >
                      <el-button
                        type="text"
                        icon="el-icon-edit"
                        style="color: #1877ff; font-size: 14px"
                        class="el-dropdown-link"
                        @click.native="dropdownSet(scope.row)"
                      >
                        编辑修改
                      </el-button>
                      <el-button
                        type="text"
                        icon="el-icon-service"
                        style="color: #1877ff; font-size: 14px"
                        class="el-dropdown-link"
                        @click.native="openCustomerServiceDialog"
                      >
                        联系客服
                      </el-button>
                      <el-button
                        type="text"
                        icon="el-icon-delete"
                        style="color: #1877ff; font-size: 14px"
                        class="el-dropdown-link"
                        @click.native="dropdownDel(scope.row)"
                      >
                        删除项目
                      </el-button>
                    </template>
                    <template
                      v-else-if="recordType == 1 && scope.row.is_draft == 0"
                    >
                      <!-- 打卡签到 -->
                      <template
                        v-if="
                          scope.row.activity_type == 109 ||
                          scope.row.activity_type == 110 ||
                          scope.row.activity_type == 104
                        "
                      >
                        <el-dropdown-item
                          icon="el-icon-edit"
                          @click.native="dropdownSet(scope.row)"
                          >编辑修改</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-user-solid"
                          @click.native="setAdmin(scope.row)"
                          >设置管理员</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-link"
                          @click.native="exportData(scope.row)"
                          >导出数据</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-data-analysis"
                          @click.native="toPageStatistics(scope.row)"
                          >数据统计</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-s-claim"
                          @click.native="goSupplementCard(scope.row)"
                          >去补卡</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-document-copy"
                          @click.native="dropdownCopy(scope.row)"
                          >复制项目</el-dropdown-item
                        >
                        <el-dropdown-item
                          v-show="
                            scope.row.activity_type != 201 &&
                            (scope.row.active_state == 1 ||
                              scope.row.active_state == 2 ||
                              scope.row.active_state == 3)
                          "
                          icon="el-icon-switch-button"
                          @click.native="dropdownEnd(scope.row)"
                          >{{
                            scope.row.active_state == 1
                              ? "立即开始"
                              : scope.row.active_state == 2
                              ? "重启活动"
                              : scope.row.active_state == 3
                              ? "提前结束"
                              : ""
                          }}</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="iconfont icon-dingdanhexiao"
                          @click.native="handleVerify(scope.row)"
                          v-if="scope.row.verification_switch == 2"
                          >核销</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-notebook-2"
                          @click.native="handleOrderManagement(scope.row)"
                          v-if="
                            scope.row.activity_type == 101 &&
                            !isStatisticsOnly(scope.row)
                          "
                          >订单管理</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="iconfont icon-saoma"
                          @click.native="handleSignCode(scope.row)"
                          v-if="scope.row.sign_in_switch == 2"
                          >签到码</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-data-line"
                          @click.native="handleSignDataScreen(scope.row)"
                          v-if="scope.row.sign_in_switch == 2"
                          >签到大屏</el-dropdown-item
                        >
                        <!-- <el-dropdown-item
                          icon="iconfont icon-anniutubiao-qingkongshuju"
                          @click.native="dropdownResetData(scope.row)"
                          :disabled="!scope.row.sign_num"
                          >清空数据</el-dropdown-item
                        > -->
                      </template>
                      <template
                        v-else-if="
                          scope.row.activity_big_type == 2 &&
                          scope.row.is_draft == 0
                        "
                      >
                        <el-dropdown-item
                          icon="el-icon-edit"
                          @click.native="dropdownSet(scope.row)"
                          >编辑修改</el-dropdown-item
                        >
                      </template>
                      <!--信息查询-->
                      <template
                        v-else-if="
                          scope.row.activity_type == 303 &&
                          scope.row.is_draft == 0
                        "
                      >
                        <el-dropdown-item
                          icon="el-icon-edit"
                          @click.native="dropdownSet(scope.row)"
                          >编辑修改</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-user-solid"
                          @click.native="setAdmin(scope.row)"
                          >设置管理员</el-dropdown-item
                        >
                        <el-dropdown-item
                          v-show="
                            scope.row.active_state == 1 ||
                            scope.row.active_state == 2 ||
                            scope.row.active_state == 3
                          "
                          icon="el-icon-switch-button"
                          @click.native="dropdownEnd(scope.row)"
                          >{{
                            scope.row.active_state == 1
                              ? "立即开始"
                              : scope.row.active_state == 2
                              ? "重启活动"
                              : scope.row.active_state == 3
                              ? "提前结束"
                              : ""
                          }}</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="iconfont icon-dingdanhexiao"
                          @click.native="handleVerify(scope.row)"
                          v-if="scope.row.verification_switch == 2"
                          >核销</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-notebook-2"
                          @click.native="handleOrderManagement(scope.row)"
                          v-if="
                            scope.row.activity_type == 101 &&
                            !isStatisticsOnly(scope.row)
                          "
                          >订单管理</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="iconfont icon-saoma"
                          @click.native="handleSignCode(scope.row)"
                          v-if="scope.row.sign_in_switch == 2"
                          >签到码</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-data-line"
                          @click.native="handleSignDataScreen(scope.row)"
                          v-if="scope.row.sign_in_switch == 2"
                          >签到大屏</el-dropdown-item
                        >
                      </template>
                      <!-- 通知公告、通用接龙 -->
                      <template v-else>
                        <el-dropdown-item
                          icon="el-icon-edit"
                          @click.native="dropdownSet(scope.row)"
                          >编辑修改</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-user-solid"
                          @click.native="setAdmin(scope.row)"
                          >设置管理员</el-dropdown-item
                        >
                        <el-dropdown-item
                          v-if="scope.row.activity_type == 106"
                          icon="el-icon-present"
                          @click.native="openRedPacketDialog(scope.row)"
                          >红包设置</el-dropdown-item
                        >
                        <el-dropdown-item
                          v-if="scope.row.activity_type == 106"
                          icon="el-icon-s-release"
                          @click.native="openChannelCodeDialog(scope.row)"
                          >渠道码</el-dropdown-item
                        >
                        <el-dropdown-item
                          v-if="scope.row.enabled === 1"
                          icon="el-icon-s-promotion"
                          @click.native="openVoteSyncDialog(scope.row)"
                          >同步至投票</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-link"
                          @click.native="exportData(scope.row)"
                          >导出数据</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-data-analysis"
                          @click.native="toPageStatistics(scope.row)"
                          >数据统计</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-document-copy"
                          @click.native="dropdownCopy(scope.row)"
                          >复制项目</el-dropdown-item
                        >
                        <el-dropdown-item
                          v-show="
                            scope.row.activity_type != 201 &&
                            (scope.row.active_state == 1 ||
                              scope.row.active_state == 2 ||
                              scope.row.active_state == 3)
                          "
                          icon="el-icon-switch-button"
                          @click.native="dropdownEnd(scope.row)"
                          >{{
                            scope.row.active_state == 1
                              ? "立即开始"
                              : scope.row.active_state == 2
                              ? "重启活动"
                              : scope.row.active_state == 3
                              ? "提前结束"
                              : ""
                          }}</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="iconfont icon-dingdanhexiao"
                          @click.native="handleVerify(scope.row)"
                          v-if="scope.row.verification_switch == 2"
                          >核销</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-notebook-2"
                          @click.native="handleOrderManagement(scope.row)"
                          v-if="
                            scope.row.activity_type == 101 &&
                            !isStatisticsOnly(scope.row)
                          "
                          >订单管理</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="iconfont icon-saoma"
                          @click.native="handleSignCode(scope.row)"
                          v-if="scope.row.sign_in_switch == 2"
                          >签到码</el-dropdown-item
                        >
                        <el-dropdown-item
                          icon="el-icon-data-line"
                          @click.native="handleSignDataScreen(scope.row)"
                          v-if="scope.row.sign_in_switch == 2"
                          >签到大屏</el-dropdown-item
                        >
                      </template>
                      <!-- 理论上只有开始和结束的时候会有数据 -->
                      <el-dropdown-item
                        icon="iconfont icon-anniutubiao-qingkongshuju"
                        @click.native="dropdownResetData(scope.row)"
                        :disabled="!scope.row.sign_num"
                        >清空数据</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-service"
                        @click.native="openCustomerServiceDialog"
                        >联系客服</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-delete"
                        @click.native="dropdownDel(scope.row)"
                        >删除项目</el-dropdown-item
                      >
                    </template>
                    <!-- 我的参与 -->
                    <template v-else-if="recordType == 4">
                      <el-dropdown-item
                        v-if="scope.row.copyStatus === 2"
                        icon="el-icon-document-copy"
                        @click.native="dropdownCopy(scope.row)"
                        >复制</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-data-analysis"
                        v-if="scope.row.activity_type != 101"
                        @click.native="goSupplementCard(scope.row)"
                        >去补卡</el-dropdown-item
                      >
                    </template>
                    <!-- 我的管理 -->
                    <template v-else-if="recordType == 5">
                      <el-dropdown-item
                        icon="el-icon-edit"
                        @click.native="dropdownSet(scope.row)"
                        >编辑修改</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-link"
                        @click.native="exportData(scope.row)"
                        >导出数据</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-data-analysis"
                        @click.native="toPageStatistics(scope.row)"
                        >数据统计</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-data-analysis"
                        @click.native="goSupplementCard(scope.row)"
                        >去补卡</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-document-copy"
                        @click.native="dropdownCopy(scope.row)"
                        >复制</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="iconfont icon-anniutubiao-qingkongshuju"
                        @click.native="dropdownResetData(scope.row)"
                        :disabled="!scope.row.sign_num"
                        >清空数据</el-dropdown-item
                      >
                    </template>
                    <el-dropdown-item
                      v-if="recordType === 1 && scope.activity_type != '101'"
                      icon="el-icon-s-check"
                      @click.native="dropdownTransfer(scope.row)"
                      >转让项目</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        style="text-align: center; margin-top: 20px"
        v-show="recordType == 3"
      >
        显示最近20条浏览记录
      </div>
      <div
        style="text-align: right; margin-top: 20px"
        v-show="tablePage.total && recordType != 3"
      >
        <el-pagination
          background
          layout="sizes,prev, pager, next,total"
          :page-sizes="[20, 50, 100, 200]"
          :total="tablePage.total"
          :current-page="tablePage.pageNum"
          :page-size="tablePage.pageSize"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="shareTitle"
      :visible.sync="dialogVisible"
      width="500px"
      top="10vh"
      center
      :show-close="false"
      custom-class="dialogClass share-qr-dialog"
    >
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">{{ shareTitle }}</span>
        <img
          class="custom-close"
          src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="dialogVisible = false"
          alt="关闭"
          title="关闭"
        />
      </span>
      <div style="text-align: center">
        <div class="radioBack">
          <el-radio-group v-model="shareChange" fill="#1877FF">
            <el-radio-button
              border="false"
              label="下载接龙二维码"
            ></el-radio-button>
            <el-radio-button
              border="false"
              label="嵌入公众号/文章"
            ></el-radio-button>
          </el-radio-group>
        </div>
        <div v-show="shareChange == '下载接龙二维码'">
          <!-- Canvas 预览区域 - 直接显示带 Logo 的二维码 -->
          <div style="margin: 20px 0">
            <canvas
              ref="logoCanvas"
              width="300"
              height="300"
              style="width: 300px; height: 300px; border-radius: 10px"
            ></canvas>
          </div>

          <!-- 控制按钮 -->
          <div class="logo-input-row" style="justify-content: center">
            <el-button
              :class="[
                'logo-circle-btn',
                'default-btn',
                { active: isDefaultMode },
              ]"
              @click="setLogoText(defaultLogoText)"
              >默认</el-button
            >
            <el-button
              v-for="(btn, index) in logoButtons"
              :key="index"
              :class="['logo-circle-btn', { active: logoText === btn.text }]"
              @click="setLogoText(btn.text)"
            >
              <span class="btn-text">{{ formatButtonText(btn.text) }}</span>
            </el-button>
            <el-button
              :class="[
                'logo-circle-btn',
                'custom-input-btn',
                { active: showCustomInput },
              ]"
              @click="enableCustomInput()"
              >自定义3-4 字</el-button
            >
          </div>

          <!-- 自定义文字输入 -->
          <div
            class="logo-input-row"
            v-if="showCustomInput"
            style="justify-content: center; margin-top: 10px"
          >
            <el-input
              v-model="logoText"
              maxlength="4"
              placeholder="输入 3-4 个字"
              class="logo-text-input"
              @input="handleLogoTextChange"
              style="width: 200px"
            ></el-input>
          </div>

          <!-- 颜色选择 -->
          <div
            class="logo-color-row"
            style="justify-content: center; margin-top: 15px"
          >
            <div
              v-for="(color, index) in logoColors"
              :key="index"
              class="color-dot"
              :class="{ active: selectedColorIndex === index }"
              :style="{ backgroundColor: color }"
              @click="selectColor(index)"
            >
              <span v-if="selectedColorIndex === index">✓</span>
            </div>
          </div>

          <!-- 协议勾选 -->
          <div
            class="logo-agreement-row"
            style="margin-top: 15px"
            v-if="!isDefaultMode"
          >
            <el-checkbox v-model="agreementChecked"
              >我已确认二维码中心logo为我自行修改</el-checkbox
            >
          </div>

          <el-button
            class="theme-btn-color"
            @click="downloadCanvasImage()"
            round
            style="margin-top: 20px"
            :disabled="!canDownload"
            >下载接龙二维码</el-button
          >
          <p
            style="text-align: left; margin-left: 20px; font-weight: 600"
            v-if="JumpUrl"
          >
            活动链接
          </p>
          <div
            style="
              background-color: #f8f8f8;
              margin: 10px;
              height: 83px;
              margin-left: 20px;
              margin-right: 20px;
              border-radius: 10px;
              border: 1px solid #e8e8e8;
            "
            v-if="JumpUrl"
          >
            <p
              style="
                padding: 5px;
                font-size: 16px;
                text-align: left;
                margin-left: 5px;
              "
            >
              {{ JumpUrl }}
            </p>

            <button
              class="theme-btn-color"
              style="
                cursor: pointer;
                font-size: 12px;
                width: 50px;
                height: 28px;
                border-radius: 15px;
                margin-top: -10px;
                margin-left: 300px;
                border: none;
              "
              @click="copyClick(JumpUrl)"
            >
              复制
            </button>
          </div>
        </div>
        <div v-show="shareChange != '下载接龙二维码'" class="wzClass">
          <div
            style="
              width: 330px;
              height: 85px;
              background-color: white;
              border-radius: 5px;
              margin: 10px;
              padding: 10px;
              margin-left: 10px;
              /* margin-top: 20px; */
            "
          >
            <div style="display: flex">
              <span
                style="
                  color: #474747;
                  font-weight: 300;
                  width: 83px;
                  text-align: left;
                "
                >小程序ID:</span
              >
              <span
                style="
                  color: #010100;
                  font-weight: 400;
                  width: 200px;
                  text-align: left;
                "
                >{{ appid }}</span
              >
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-left: 0px;
                margin-top: 15px;
              "
            >
              <div>
                <span style="color: red; line-height: 28px; text-align: left"
                  >*</span
                >
                <span
                  style="
                    color: #1877ff;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 28px;

                    text-align: left;
                  "
                  >关联小程序时使用</span
                >
              </div>

              <el-button
                class="theme-btn-color-gzh"
                size="mini"
                round
                @click="copyClick(appid)"
              >
                复制
              </el-button>
            </div>
          </div>

          <div
            style="
              width: 330px;
              min-height: 100px;
              background-color: white;
              border-radius: 5px;
              margin: 10px;
              padding: 10px;
              margin-left: 10px;
            "
          >
            <div style="display: flex">
              <span
                style="
                  color: #474747;
                  font-weight: 300;
                  width: 83px;
                  text-align: left;
                "
                >页面路径:</span
              >

              <span
                style="
                  color: #010100;
                  font-weight: 400;
                  width: 200px;
                  text-align: left;
                "
                >{{ faceUrl }}</span
              >
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-left: 0px;
                margin-top: 15px;
              "
            >
              <div>
                <span style="color: red; line-height: 28px; text-align: left"
                  >*</span
                >
                <span
                  style="
                    color: #1877ff;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 28px;
                    text-align: left;
                  "
                  >嵌入菜单，文章，回复时使用</span
                >
              </div>
              <el-button
                class="theme-btn-color-gzh"
                size="mini"
                round
                @click="copyClick(faceUrl)"
              >
                复制
              </el-button>
            </div>
          </div>
          <div
            style="
              width: 330px;
              background-color: white;
              border-radius: 5px;
              margin: 10px;
              padding: 10px;
              margin-left: 10px;
            "
          >
            <div
              style="
                text-align: center;
                font-size: 20px;
                font-weight: 500;
                margin-top: 30px;
              "
            >
              使用教程
            </div>

            <div style="margin-top: 10px; margin-bottom: 10px">
              <button
                style="cursor: pointer; border-radius: 8px 0 0 8px"
                :class="isAcive == '嵌入到公众号' ? 'acStyle' : 'defStyle'"
                @click="clickHandler"
              >
                嵌入到公众号
              </button>

              <button
                style="cursor: pointer; border-radius: 0 8px 8px 0"
                :class="isAcive == '嵌入到文章' ? 'acStyle' : 'defStyle'"
                @click="clickHandler"
              >
                嵌入到文章
              </button>

              <!-- kEu47kwFr2oOr9rO/modularImg/1707035652084.jpg -->
            </div>

            <div v-show="isAcive == '嵌入到公众号'">
              <el-image
                style="width: 300px"
                :src="require('@/assets/images/qrgzh.jpg')"
              >
              </el-image>
            </div>

            <div v-show="isAcive == '嵌入到文章'">
              <el-image
                style="width: 300px"
                :src="
                  imageUrl + 'kEu47kwFr2oOr9rO/modularImg/1707035652084.jpg'
                "
              >
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="customerServiceDialogVisible"
      width="360px"
      :show-close="false"
      custom-class="customer-service-dialog"
    >
      <div slot="title" class="cs-dialog-header">
        <span>联系客服</span>
        <i class="el-icon-close" @click="closeCustomerServiceDialog"></i>
      </div>
      <div class="cs-dialog-content">
        <img :src="customerServiceQrcodeSrc" alt="客服二维码" />
        <p>扫码联系客服微信获取帮助</p>
      </div>
    </el-dialog>
    <!-- 新建文件夹对话框 -->
    <el-dialog
      :title="foldertype == 1 ? '新建文件夹' : '重命名'"
      :visible.sync="showCreateFolderDialog"
      width="400px"
      :show-close="false"
    >
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">{{
          foldertype == 1 ? "新建文件夹" : "重命名"
        }}</span>
        <img
          class="custom-close"
          src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="closeCreateFolderDialog"
          alt="关闭"
          title="关闭"
        />
      </span>
      <el-input
        v-model="folderName"
        placeholder="请输入文件夹名称"
        maxlength="10"
        show-word-limit
        clearable
        class="custom-input"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeCreateFolderDialog">取 消</el-button>
        <el-button type="primary" @click="createFolder">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 移动文件夹对话框-->
    <el-dialog
      title="选择文件夹"
      :visible.sync="moveDialogVisible"
      width="400px"
      @close="
        moveFolderId = '';
        moveType = 2;
      "
      center
      :show-close="false"
    >
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">选择文件夹</span>
        <img
          class="custom-close"
          src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="
            moveFolderId = '';
            moveType = 2;
          "
          alt="关闭"
          title="关闭"
        />
      </span>
      <el-radio-group v-model="moveType" style="margin-bottom: 16px">
        <el-radio :label="1">新建文件夹</el-radio>
        <el-radio :label="2">现有文件夹</el-radio>
      </el-radio-group>
      <div v-if="moveType === 1">
        <el-input
          v-model="folderName"
          placeholder="请输入文件夹名称"
          maxlength="30"
          show-word-limit
          clearable
        >
        </el-input>
      </div>
      <div v-if="moveType === 2">
        <el-radio-group
          v-model="moveFolderId"
          class="folder-radio-group"
          style="width: 100%"
        >
          <div
            style="width: 100%"
            v-for="folder in folderList"
            :key="folder.id"
            class="folder-radio-item folder-radio-item-custom"
            @click="moveFolderId = folder.id"
            :class="{ 'is-checked': moveFolderId === folder.id }"
          >
            <i
              class="el-icon-folder"
              style="font-size: 18px; margin-right: 8px; vertical-align: middle"
            ></i>
            <span style="vertical-align: middle; font-size: 14px">{{
              folder.folderName
            }}</span>
            <span class="custom-radio-circle">
              <span class="circle-outer">
                <span
                  class="circle-inner"
                  v-if="moveFolderId === folder.id"
                ></span>
              </span>
            </span>
          </div>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="moveDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmMove">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="manageTitle"
      custom-class="dialogClassShare"
      :visible.sync="manageDialogVisible"
      width="455px"
      center
      :show-close="false"
    >
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">{{ manageTitle }}</span>
        <img
          class="custom-close"
          src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="manageDialogVisible = false"
          alt="关闭"
          title="关闭"
        />
      </span>
      <div
        style="
          text-align: center;
          background-color: #f6f7fa;
          padding-top: 0px;
          padding-bottom: 30px;
          margin: -25px -25px -30px;
        "
      >
        <div>
          <el-image :src="codeUrl" class="code-image"></el-image>
        </div>
        <div>{{ manageTip }}</div>
        <el-button
          @click="downloadIamge(codeUrl, new Date().valueOf())"
          type="primary"
          round
          style="margin-top: 40px"
          >下载接龙二维码</el-button
        >
      </div>
    </el-dialog>

    <!-- 渠道码弹窗 -->
    <el-dialog
      :title="'渠道码'"
      custom-class="dialogClass"
      :visible.sync="channelCodeDialogVisible"
      width="455px"
      center
      :show-close="false"
    >
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">渠道码</span>
        <img
          class="custom-close"
          src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="channelCodeDialogVisible = false"
          alt="关闭"
          title="关闭"
        />
      </span>
      <div
        style="
          text-align: center;
          background-color: #f6f7fa;
          padding-top: 0px;
          padding-bottom: 30px;
          margin: -25px -25px -30px;
        "
      >
        <div>
          <el-image :src="channelCodeUrl" class="code-image"></el-image>
        </div>
        <div>请扫码去小程序操作</div>
      </div>
    </el-dialog>

    <!-- 参与数据同步至投票管家弹窗 -->
    <el-dialog
      :title="'参与数据同步至投票管家'"
      custom-class="dialogClass"
      :visible.sync="voteSyncDialogVisible"
      width="455px"
      center
      :show-close="false"
    >
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">参与数据同步至投票管家</span>
        <img
          class="custom-close"
          src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="voteSyncDialogVisible = false"
          alt="关闭"
          title="关闭"
        />
      </span>
      <div
        style="
          text-align: center;
          background-color: #f6f7fa;
          padding-top: 0px;
          padding-bottom: 30px;
          margin: -25px -25px -30px;
        "
      >
        <div>
          <el-image :src="voteSyncCodeUrl" class="code-image"></el-image>
        </div>
        <div>请扫码去小程序操作</div>
      </div>
    </el-dialog>

    <el-dialog
      title="签到数据大屏"
      :visible.sync="signDataScreenBoxShow"
      width="455px"
      center
      :show-close="false"
      custom-class="dialogClass"
    >
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">签到数据大屏</span>
        <img
          class="custom-close"
          src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="signDataScreenBoxShow = false"
          alt="关闭"
          title="关闭"
        />
      </span>
      <div style="text-align: center; background-color: #f8f8f8">
        <div
          style="
            height: 85px;
            background-color: white;
            border-radius: 5px;
            margin-bottom: 10px;
            margin-top: -10px;
            padding: 10px;
            /* margin-top: 20px; */
          "
        >
          <div style="display: flex">
            <span style="color: #2b2f36; font-weight: 400; text-align: left">{{
              DataScreenUrl
            }}</span>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-left: 0px;
              margin-top: 15px;
            "
          >
            <div>
              <span
                style="
                  color: #2b2f36;
                  font-size: 16px;
                  font-weight: 600;
                  line-height: 28px;

                  text-align: left;
                "
                >访问秘钥:</span
              >
              <span style="color: #1877ff; font-size: 16px"> {{ key }}</span>
            </div>

            <el-button
              class="theme-btn-color-sjdp"
              size="mini"
              round
              @click="copyClick(DataScreenUrl)"
            >
              复制地址
            </el-button>
          </div>
        </div>
        <template v-if="browserList.length">
          <div
            class="browser-info"
            v-for="(item, index) in browserList"
            :key="index"
          >
            <div class="info-left">
              <div class="info-title">当前使用</div>
              <div class="info-content">{{ item.browserName }}</div>
              <div class="info-content">IP：{{ item.ip }}</div>
            </div>
            <el-button type="text" class="offline-btn" @click="offline(index)"
              >下线</el-button
            >
          </div>
        </template>

        <div>
          <img
            style="width: 100%"
            src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/dataScreen-xiaoguo.png"
            mode="widthFix"
            v-if="appid == 'wx1e899bddb256a5ca'"
          />
          <img
            style="width: 100%"
            src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/largeDataSrcenbmgj.png"
            mode="widthFix"
            v-else
          />
        </div>
      </div>
    </el-dialog>

    <!-- 红包设置弹窗 -->
    <el-dialog
      title="红包设置"
      :visible.sync="redPacketDialogVisible"
      width="800px"
      center
      :show-close="false"
      custom-class="dialogClass"
    >
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">红包设置</span>
        <img
          class="custom-close"
          src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="redPacketDialogVisible = false"
          alt="关闭"
          title="关闭"
        />
      </span>
      <div class="red-packet-dialog-content">
        <!-- 红包列表 -->
        <div class="red-packet-list" v-if="redPacketList.length > 0">
          <div
            class="red-packet-card"
            v-for="(item, index) in redPacketList"
            :key="index"
          >
            <div class="red-packet-header">
              <img
                class="red-packet-icon"
                :src="
                  item.type === 1
                    ? 'https://ossfastmake.xlkapp.com/qrCode/tupian/1766556738098.svg'
                    : 'https://ossfastmake.xlkapp.com/qrCode/tupian/1766556738098.svg'
                "
                alt=""
              />
              <span class="red-packet-title">{{
                item.packetType === 1 ? "固定金额红包" : "拼手气红包"
              }}</span>
            </div>
            <div class="red-packet-divider"></div>
            <div class="red-packet-body">
              <div class="red-packet-item">
                <span class="item-label">已领取金额：</span>
                <span class="item-value"
                  >¥{{ item.receivedAmount || 0 }}/{{
                    item.totalAmount || 0
                  }}</span
                >
                <span class="item-link" @click="viewRedPacketDetail(item)"
                  >查看领取详情</span
                >
              </div>
              <div class="red-packet-item">
                <span class="item-label">红包发送人昵称：</span>
                <span class="item-value">{{
                  item.senderName || "某某某"
                }}</span>
              </div>
              <div class="red-packet-item">
                <span class="item-label">中奖概率：</span>
                <span class="item-value">{{ item.probability || 100 }}%</span>
              </div>
              <div class="red-packet-item">
                <span class="item-label">抽奖条件：</span>
                <span class="item-value">{{
                  item.lotteryRuleType == 1
                    ? "每个账号仅允许抽取一次"
                    : "每个账号参与次数与抽奖次数一致"
                }}</span>
              </div>
              <div class="red-packet-item">
                <span class="item-label">创建时间：</span>
                <span class="item-value">{{ item.createTime }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 暂无红包提示 -->
        <div class="no-red-packet" v-else>
          <img
            src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/tjfx-nodata.svg"
            alt="暂无数据"
          />
          <p>暂无红包详情，请添加红包</p>
        </div>
        <!-- 继续添加红包按钮 -->
        <div style="text-align: center; margin-top: 20px">
          <el-button
            type="primary"
            @click="openAddRedPacketDialog"
            icon="el-icon-plus"
            >继续添加红包</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 领取详情弹窗 -->
    <ClaimDetailDialog
      v-model="claimDetailDialogVisible"
      :list="claimDetailList"
      :summary="claimDetailSummary"
    />

    <!-- 支付二维码弹窗 -->
    <el-dialog
      :visible.sync="paymentQrcodeDialogVisible"
      width="420px"
      :show-close="false"
      custom-class="payment-qrcode-dialog"
      @close="closePaymentQrcodeDialog"
    >
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">扫码支付</span>
        <img
          class="custom-close"
          src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="handleClosePaymentQrcode"
          alt="关闭"
          title="关闭"
        />
      </span>
      <div class="payment-qrcode-content">
        <div class="payment-info-item">
          <span class="info-label">应付金额：</span>
          <span class="info-value amount">¥ {{ paymentInfo.amount }}</span>
        </div>
        <div class="payment-info-item">
          <span class="info-label">订单编号：</span>
          <span class="info-value">{{ paymentInfo.orderNo }}</span>
        </div>
        <div class="payment-info-item">
          <span class="info-label">有效期：</span>
          <span class="info-value"
            >{{ paymentInfo.createTime }} 至 无限有效期</span
          >
        </div>
        <div class="qrcode-section">
          <div class="wechat-pay-logo">
            <img src="@/assets/images/WeChatpay.svg" alt="微信支付" />
          </div>
          <img :src="paymentQrcode" alt="支付二维码" />
          <p class="scan-tip">用微信扫一扫即可付款</p>
          <el-button
            type="primary"
            size="small"
            @click="checkPaymentStatus"
            :loading="checkingPayment"
            style="margin-top: 15px"
          >
            我已支付
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 添加红包弹窗 -->
    <el-dialog
      title="设置红包"
      :visible.sync="addRedPacketDialogVisible"
      width="650px"
      center
      :show-close="false"
      custom-class="dialogClass"
    >
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">设置红包</span>
        <img
          class="custom-close"
          src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="addRedPacketDialogVisible = false"
          alt="关闭"
          title="关闭"
        />
      </span>
      <div class="add-red-packet-dialog-content">
        <el-form
          :model="redPacketForm"
          :rules="redPacketRules"
          ref="redPacketFormRef"
          label-width="120px"
          label-position="left"
        >
          <!-- 第一排：红包抽中概率、红包发送人昵称 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="红包抽中概率" prop="probability">
                <el-input
                  v-model="redPacketForm.probability"
                  type="number"
                  placeholder="请输入概率"
                  style="width: 100%"
                  @input="limitProbability"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发送人昵称" prop="name">
                <el-input
                  v-model="redPacketForm.name"
                  placeholder="请输入昵称"
                  maxlength="15"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二排：红包类型 -->
          <el-form-item label="红包类型" prop="type">
            <el-radio-group v-model="redPacketForm.type">
              <el-radio :label="1">固定金额红包</el-radio>
              <el-radio :label="2">拼手气红包</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 第三排：固定金额红包 - 单个金额、红包个数 -->
          <el-row :gutter="20" v-if="redPacketForm.type === 1">
            <el-col :span="12">
              <el-form-item label="单个金额" prop="singleAmount">
                <el-input
                  v-model="redPacketForm.singleAmount"
                  type="number"
                  placeholder="0.1-200"
                  style="width: 100%"
                  @input="limitSingleAmount"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="红包个数" prop="redEnvelopesNumber">
                <el-input
                  v-model="redPacketForm.redEnvelopesNumber"
                  type="number"
                  placeholder="1-1000"
                  style="width: 100%"
                  @input="limitRedEnvelopeNumber"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第三排：拼手气红包 - 总金额、红包个数 -->
          <el-row :gutter="20" v-if="redPacketForm.type === 2">
            <el-col :span="12">
              <el-form-item label="总金额" prop="totalAmount">
                <el-input
                  v-model="redPacketForm.totalAmount"
                  type="number"
                  placeholder="请输入总金额"
                  style="width: 100%"
                  @input="limitTotalAmount"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="红包个数" prop="redEnvelopesNumber">
                <el-input
                  v-model="redPacketForm.redEnvelopesNumber"
                  type="number"
                  placeholder="1-1000"
                  style="width: 100%"
                  @input="limitRedEnvelopeNumber"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第四排：拼手气红包 - 单个红包范围 -->
          <el-row :gutter="20" v-if="redPacketForm.type === 2">
            <el-col :span="12">
              <el-form-item label="最小金额" prop="minimumAmount">
                <el-input
                  v-model="redPacketForm.minimumAmount"
                  type="number"
                  placeholder="最小金额"
                  style="width: 100%"
                  @input="limitMinimumAmount"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最大金额" prop="maximumAmount">
                <el-input
                  v-model="redPacketForm.maximumAmount"
                  type="number"
                  placeholder="最大金额"
                  style="width: 100%"
                  @input="limitMaximumAmount"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 抽奖条件 -->
          <el-form-item label="抽奖条件" prop="lotteryRuleType">
            <el-radio-group v-model="redPacketForm.lotteryRuleType">
              <el-radio :label="1">每个账号仅允许抽取一次</el-radio>
              <el-radio :label="2">每个账号参与次数与抽奖次数一致</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 温馨提示 -->
          <div class="red-packet-tips">
            <div class="tips-title">温馨提示：</div>
            <div class="tips-content">
              <p>
                1.若红包金额未被领取完毕，您可在活动结束或手动结束后，进入「个人中心一充值订单」页面，申请退回剩余金额。
              </p>
              <p>
                2.开通的红包暂不支持开具发票，如有其他疑问，请<span
                  class="tips-link"
                  @click="openCustomerServiceDialog"
                  >联系客服</span
                >。
              </p>
              <p class="tips-red">
                3.为确保公平与真实，领取情况、中奖概率等信息将被公开。
              </p>
              <p>4.平台根据总金额将收取1%的手续费，小于10元不收取费用。</p>
            </div>
          </div>

          <!-- 总金额显示 -->
          <div class="red-packet-total-price">
            <span>总金额：</span>
            <span class="price-value">¥{{ redPacketCalculatedPrice }}</span>
            <span class="price-tip">(红包总金额+手续费)</span>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addRedPacketDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="submitRedPacket"
          :loading="redPacketSubmitting"
          :disabled="!isRedPacketFormValid"
          >确认支付</el-button
        >
      </span>
    </el-dialog>
  </Layout>
</template>

<script>
import axios from "axios";
import pako from "pako";
import iconvLite from "iconv-lite";
import appConfig from "@/app.config";
import Layout from "../../layouts/main";

// import router from "../../../router/index";

import { mapActions, mapState } from "vuex";
import {
  activityDetail,
  delActivity,
  delSignOrder,
  earlyTermination,
  getActivityCode,
  getCreateList,
  getFolderShareLink,
  getShareLink,
  restartActivity,
  selBrowseHistory,
  startImmediately,
  createRedPacketOrder,
  calculateRedPacketPrice,
  getRedPacketList,
  getClaimDetail,
  createRedPacketOrderPc,
  checkRedPacketPaymentStatus,
} from "@/utils/api/activity";
import {
  allFolder,
  create,
  creFolderActivityByAcid,
  delTooActivity,
  folderDetete,
  update,
} from "@/utils/api/folder";
import { imageUrl } from "@/utils/config/commonUrl.js";
import copyrightConfig from "@/utils/config/changeCopyright.js";
import serverConfig from "@/utils/config/index.js";
import ClaimDetailDialog from "@/components/ClaimDetailDialog/ClaimDetailDialog.vue";
const appid = copyrightConfig.AppID;

/**

 * Basic-table component

 */

export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
    title: "我的项目",
  },

  components: { Layout, ClaimDetailDialog },

  data() {
    return {
      searchName: "",
      publishTime: [],
      timeFilter: "", // 新增：时间筛选下拉
      customTimeRange: [], // 新增：自定义时间范围
      showCustomTimePicker: false, // 新增：是否显示自定义时间选择器
      timeRange: "",
      timeRangeName: "",
      datetimerange: [],
      activeStateName: "",
      statusOptions: [
        { label: "全部", value: "全部" },
        { label: "进行中", value: "进行中" },
        { label: "未开始", value: "未开始" },
        { label: "已结束", value: "已结束" },
        { label: "草稿", value: "草稿" },
      ],

      showCreateFolderDialog: false,
      folderName: "",
      batchEditMode: false, // 是否批量编辑模式
      selectedRows: [], // 已选中的行
      imageUrl: imageUrl,
      codeUrl: "",
      options: [
        { label: "全部", value: "" },
        { label: "通用场景", value: 106 },
        { label: "打卡签到", value: 109 },
        // { label: "通知公告", value: 201 },
        { label: "信息查询", value: 303 },
        { label: "收费报名", value: 101 },
      ],
      timeoptions: [
        { label: "最新发布", value: 1 },

        { label: "最早发布", value: 2 },
      ],
      tableData: [],
      dialogVisible: false,
      shareChange: "下载接龙二维码",
      appid: "wx1e899bddb256a5ca",
      faceUrl: "/page/index/index",
      recordType: 1, //1我的发布   4 我的参加 5 我的管理
      logoText: "",
      logoTextDisplay: "",
      selectedColorIndex: -1, // 默认不选中任何颜色
      defaultLogoColor: "#133BBE", // 默认模式的背景颜色
      agreementChecked: false,
      logoColors: [
        "#C72827",
        "#EF6C00",
        "#F9A824",
        "#00695C",
        "#568C2E",
        "#1465C0",
        "#4626A1",
        "#464646",
        "#262222",
      ],
      showCustomInput: false, // 是否显示自定义输入框
      canvasCodeUrl: "", // Canvas 使用的二维码 URL
      logoButtons: [], // 动态按钮列表
      defaultLogoText: "", // 默认 Logo 文字
      isDefaultMode: true, // 是否是默认模式（不显示中心圆形 Logo）
      items: [
        { label: "我的发布", value: 1 },
        { label: "我的参加", value: 4 },
        { label: "我的管理", value: 5 },
        { label: "我的浏览", value: 3 },
      ],
      activeTag: 1, //1我的发布   4 我的参加
      isAcive: "嵌入到公众号",
      activityType: "", //106 接龙和 109打卡类型
      activeState: "",
      sortType: 1, //1、倒序 2、正序
      tablePage: {
        pageNum: 1, //
        pageSize: 20,
        total: 0,
      },
      shareTitle: "分享",
      JumpUrl: "", //投票链接
      foldertype: 1, //文件夹类型1创建2重命名
      currentFolderID: "", //当前文件夹ID
      moveDialogVisible: false, // 控制弹窗显示
      moveType: 2, // 1新建 2现有
      moveFolderId: "", // 选中的文件夹id
      folderList: [], // 文件夹列表
      isDraft: "", //是否为草稿
      startTime: "",
      endTime: "",
      manageDialogVisible: false,
      manageTip: "",
      manageTitle: "",
      channelCodeDialogVisible: false, // 渠道码弹窗
      channelCodeUrl: "", // 渠道码 URL
      voteSyncDialogVisible: false, // 参与数据同步至投票管家弹窗
      voteSyncCodeUrl: "", // 投票管家小程序码
      routeParameter: "", // 链接参数
      shareFn: 2,
      loadingShow: {},
      customerServiceDialogVisible: false,
      customerServiceQrcodeSrc:
        appid === "wx7d8daf6d777947a2"
          ? "https://ossfastmake.xlkapp.com//12jielong/bdJL/bmkfblue.png"
          : "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/lsyJL/jljj_kf_new.png",
      signDataScreenBoxShow: false,
      DataScreenUrl: "",
      key: "", //数据大屏访问密码
      browserList: [],
      currentActivityKey: "", // 当前活动的 activity_key

      // 红包设置相关
      redPacketDialogVisible: false, // 红包设置弹窗显示
      addRedPacketDialogVisible: false, // 添加红包弹窗显示
      redPacketList: [], // 红包列表
      redPacketPageNum: 1, // 红包列表页码
      redPacketPageSize: 10, // 红包列表每页数量
      currentRedPacketRow: null, // 当前操作的活动行数据
      // 领取详情相关
      claimDetailDialogVisible: false, // 领取详情弹窗显示
      claimDetailList: [], // 领取详情列表
      currentPacketId: null, // 当前红包 ID
      claimDetailPageNum: 1, // 领取详情页码
      claimDetailPageSize: 10, // 领取详情每页数量
      claimDetailTotal: 0, // 领取详情总数
      claimDetailSummary: {}, // 领取详情汇总信息
      // 支付二维码相关
      paymentQrcodeDialogVisible: false, // 支付二维码弹窗显示
      paymentQrcode: "", // 支付二维码 base64
      paymentInfo: {
        amount: "", // 应付金额
        orderNo: "", // 订单编号
        createTime: "", // 下单时间
      },
      checkingPayment: false, // 是否正在检查支付状态
      paymentCheckTimer: null, // 支付检查定时器
      redPacketForm: {
        probability: "", // 红包抽中概率
        name: "", // 红包发送人昵称
        type: 1, // 红包类型 1固定金额 2拼手气
        singleAmount: "", // 固定金额单个金额
        totalAmount: "", // 拼手气红包总金额
        minimumAmount: "", // 单个红包金额范围最小
        maximumAmount: "", // 单个红包金额范围最大
        redEnvelopesNumber: "", // 红包个数
        lotteryRuleType: 1, // 抽奖规则类型 1每个账号仅允许抽取一次 2每个账号参与次数与抽奖次数一致
      },
      redPacketRules: {
        probability: [
          { required: true, message: "请设置红包抽中概率", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入发送人昵称", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择红包类型", trigger: "change" },
        ],
        singleAmount: [
          { required: true, message: "请输入单个金额", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              let num = parseFloat(value);
              if (isNaN(num) || num < 0.1 || num > 200) {
                callback(new Error("金额范围为 0.1-200 元"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        totalAmount: [
          { required: true, message: "请输入总金额", trigger: "blur" },
        ],
        redEnvelopesNumber: [
          { required: true, message: "请输入红包个数", trigger: "blur" },
        ],
        lotteryRuleType: [
          { required: true, message: "请选择抽奖条件", trigger: "change" },
        ],
        minimumAmount: [
          { required: true, message: "请输入最小金额", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              let num = parseFloat(value);
              let maxNum = parseFloat(this.redPacketForm.maximumAmount);
              if (isNaN(num) || num < 0.1 || num > 199) {
                callback(new Error("最小金额范围为0.1-199元"));
              } else if (!isNaN(maxNum) && num >= maxNum) {
                callback(new Error("最小金额必须小于最大金额"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        maximumAmount: [
          { required: true, message: "请输入最大金额", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              let num = parseFloat(value);
              let minNum = parseFloat(this.redPacketForm.minimumAmount);
              if (isNaN(num) || num < 0.1 || num > 200) {
                callback(new Error("最大金额范围为0.1-200元"));
              } else if (!isNaN(minNum) && num <= minNum) {
                callback(new Error("最大金额必须大于最小金额"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      // 红包计算价格
      redPacketCalculatedPrice: 0,
      // 红包提交loading
      redPacketSubmitting: false,
    };
  },
  computed: {
    // 从 vuex 获取状态
    ...mapState("commonData", ["nickname", "type", "message", "isOpenShare"]),
    canDownload() {
      // 默认模式不需要勾选协议，其他模式需要勾选
      if (this.isDefaultMode) {
        return true;
      }
      return this.agreementChecked;
    },
    headerCellStyle() {
      return {
        background: "#F1F3F8",
        color: "#3A3A3C",
        fontWeight: "bold",
      };
    },
    // 检查红包表单是否填写完整
    isRedPacketFormValid() {
      // 必填字段检查
      if (
        !this.redPacketForm.probability ||
        !this.redPacketForm.name ||
        !this.redPacketForm.redEnvelopesNumber ||
        !this.redPacketForm.lotteryRuleType
      ) {
        return false;
      }
      // 根据红包类型检查不同字段
      if (this.redPacketForm.type === 1) {
        // 固定金额红包需要 singleAmount，且最低 0.1
        if (
          !this.redPacketForm.singleAmount ||
          this.redPacketForm.singleAmount < 0.1
        ) {
          return false;
        }
      } else if (this.redPacketForm.type === 2) {
        // 拼手气红包需要 totalAmount、minimumAmount、maximumAmount
        if (
          !this.redPacketForm.totalAmount ||
          !this.redPacketForm.minimumAmount ||
          !this.redPacketForm.maximumAmount
        ) {
          return false;
        }
      }
      return true;
    },
  },
  watch: {
    // 监听红包金额变化，计算价格
    "redPacketForm.singleAmount"(val) {
      if (val && this.redPacketForm.type === 1) {
        this.calculatePrice();
      }
    },
    "redPacketForm.totalAmount"(val) {
      if (val && this.redPacketForm.type === 2) {
        this.calculatePrice();
      }
    },
    "redPacketForm.redEnvelopesNumber"(val) {
      if (val && val > 0) {
        this.calculatePrice();
      }
    },
    "redPacketForm.type"() {
      // 切换类型时重置计算价格
      this.redPacketCalculatedPrice = null;
    },
  },
  created() {
    this.getCreateList();
    this.initLogoButtons();
    // console.log(localStorage.getItem("userID"),"用户ID");
  },
  mounted() {
    this.routeParameter = this.$route.query;
    if (this.routeParameter.shareFn) {
      this.shareFn = this.routeParameter.shareFn;
    }
    // 确保标题设置生效
    this.$nextTick(() => {
      this.setPageTitle();
    });
  },
  methods: {
    // 限制概率输入为 1-100 的数字
    limitProbability(value) {
      let num = parseInt(value);
      if (isNaN(num) || num < 1) {
        this.redPacketForm.probability = 1;
      } else if (num > 100) {
        this.redPacketForm.probability = 100;
      }
    },
    // 限制红包个数为 1-1000 的数字
    limitRedEnvelopeNumber(value) {
      let num = parseInt(value);
      if (isNaN(num) || num < 1) {
        this.redPacketForm.redEnvelopesNumber = 1;
      } else if (num > 1000) {
        this.redPacketForm.redEnvelopesNumber = 1000;
      }
    },
    // 限制金额输入 (0.1-200)
    limitSingleAmount(value) {
      let num = parseFloat(value);
      if (isNaN(num) || num < 0.1) {
        this.redPacketForm.singleAmount = 0.1;
      } else if (num > 200) {
        this.redPacketForm.singleAmount = 200;
      }
    },
    // 限制总金额输入
    limitTotalAmount(value) {
      let num = parseFloat(value);
      if (isNaN(num) || num < 0.1) {
        this.redPacketForm.totalAmount = 0.1;
      }
    },
    // 限制最小金额输入
    limitMinimumAmount(value) {
      let num = parseFloat(value);
      if (isNaN(num) || num < 0.1) {
        this.redPacketForm.minimumAmount = 0.1;
      }
    },
    // 限制最大金额输入
    limitMaximumAmount(value) {
      let num = parseFloat(value);
      if (isNaN(num) || num < 0.1) {
        this.redPacketForm.maximumAmount = 0.1;
      }
    },
    // 格式化按钮文字，超过 2 个字就换行
    formatButtonText(text) {
      if (text.length <= 2) {
        return text;
      }
      const firstRow = text.slice(0, 2);
      const secondRow = text.slice(2, 4);
      return firstRow + "\n" + secondRow;
    },
    // 初始化 Logo 按钮
    initLogoButtons() {
      const isBaomingGuanjia = copyrightConfig.AppID === "wx7d8daf6d777947a2";

      // 根据 AppID 设置默认文字和颜色
      if (isBaomingGuanjia) {
        // 报名管家
        this.defaultLogoText = "报名";
        this.defaultLogoColor = "#2577e4";
        this.logoButtons = [{ text: "接龙" }];
      } else {
        // 接龙加加
        this.defaultLogoText = "接龙";
        this.defaultLogoColor = "#133BBE";
        this.logoButtons = [];
      }

      // 添加固定按钮
      const commonButtons = [
        { text: "签到" },
        { text: "打卡" },
        { text: "通知" },
        { text: "学校" },
        { text: "信息收集" },
        { text: "登记" },
      ];
      this.logoButtons = [...this.logoButtons, ...commonButtons];

      // 设置初始 logoText 为默认文字
      this.logoText = this.defaultLogoText;
    },

    // 设置页面标题
    setPageTitle() {
      // 根据 AppID 确定后缀
      let suffix = "接龙加加";
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = "报名管家";
      }

      document.title = `发布记录 - ${suffix}`;
      console.log(document.title, "document.title");
    },
    handleOrderManagement(row) {
      console.log(row);
      // const routeData = this.$router.resolve({
      //   path: `/orderManagementList?activityId=${row.id}&activityName=${row.name}`,
      // });
      // window.open(routeData.href, "_blank");

      this.$router.push({
        path: "/orderManagementList",
        query: {
          activityId: row.id,
          activityName: row.name,
        },
      });
    },
    openCustomerServiceDialog() {
      this.customerServiceDialogVisible = true;
    },
    closeCustomerServiceDialog() {
      this.customerServiceDialogVisible = false;
    },
    // 关闭支付二维码弹窗
    closePaymentQrcodeDialog() {
      this.paymentQrcodeDialogVisible = false;
      // 清除定时器
      if (this.paymentCheckTimer) {
        clearInterval(this.paymentCheckTimer);
        this.paymentCheckTimer = null;
      }
    },
    // 手动关闭支付弹窗
    handleClosePaymentQrcode() {
      this.paymentQrcodeDialogVisible = false;
    },
    // 检查支付状态
    checkPaymentStatus() {
      this.checkingPayment = true;
      // 调用接口检查支付状态
      this.checkPaymentStatusApi();
      // // 轮询检查支付状态，每 3 秒检查一次
      // this.paymentCheckTimer = setInterval(() => {
      //   this.checkPaymentStatusApi();
      // }, 3000);
    },
    // 检查支付状态接口
    async checkPaymentStatusApi() {
      try {
        const res = await checkRedPacketPaymentStatus({
          orderNo: this.paymentInfo.orderNo,
        });
        console.log("检查支付状态结果:", res);
        if (res.tradeState == "SUCCESS") {
          console.log(res, "res");
          // 支付成功
          this.handlePaymentSuccess();
        } else {
          this.$message.error(res.tradeStateDesc);
        }
      } catch (error) {
        // this.$message.error(res.tradeStateDesc);
        console.error("检查支付状态失败:", error);
      } finally {
        this.checkingPayment = false;
      }
    },
    // 支付成功处理
    handlePaymentSuccess() {
      // 清除定时器
      if (this.paymentCheckTimer) {
        clearInterval(this.paymentCheckTimer);
        this.paymentCheckTimer = null;
      }
      this.$message.success("支付成功！");
      this.paymentQrcodeDialogVisible = false;
      this.addRedPacketDialogVisible = false;
      // 刷新红包列表
      if (this.currentRedPacketRow && this.currentRedPacketRow.id) {
        this.getRedPacketListData(this.currentRedPacketRow.id);
      }
    },
    async _currentUsage(activityKey) {
      try {
        const result = await axios({
          url: `${serverConfig.baseURL}/screen/getUserUrl`,
          method: "GET",
          // 核心：仅本次请求添加 alias 头
          headers: {
            "Content-Type": "application/json",
            appId: copyrightConfig.AppID,
            alias: activityKey,
            "Access-Token": localStorage.getItem("token") || "",
          },
        });

        // 业务逻辑处理
        if (result.data.status == 1) {
          this.browserList = [
            {
              ip: result.data.data.ip,
              browserName: result.data.data.browserName,
            },
          ];
        } else {
          console.log(result.data, "fjeojfosejfo");
        }
      } catch (error) {
        console.error("获取用户信息失败:", error);
      }
    },
    // 下线
    offline(i) {
      this.commIndex = i;
      this.$confirm("确定下线？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this._offlineUsers();
        })
        .catch(() => {});
    },
    // 下线用户
    async _offlineUsers() {
      try {
        const result = await axios({
          url: `${serverConfig.baseURL}/screen/offlineUsers`,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            appId: copyrightConfig.AppID,
            alias: this.currentActivityKey,
            "Access-Token": localStorage.getItem("token") || "",
          },
        });
        if (result.data.status == 1) {
          this.$message.success("下线成功");
          this.browserList = [];
          this._currentUsage(this.currentActivityKey);
        }
      } catch (error) {
        console.error("下线失败：", error);
      }
    },
    async _getAccessKey(row) {
      console.log("看看执行没_getAccessKey");
      try {
        const result = await axios({
          url: `${serverConfig.baseURL}/screen/getAccessKey`,
          method: "POST",
          data: {
            url: this.codeUrl,
            name: row.name,
            appId: copyrightConfig.AppID,
          },
          // 核心：仅本次请求添加 alias 头
          headers: {
            "Content-Type": "application/json",
            appId: copyrightConfig.AppID,
            alias: row.activity_key,
            "Access-Token": localStorage.getItem("token") || "",
          },
        });
        console.log(result, "result");
        // 业务逻辑处理
        if (result.data.status == 1) {
          console.log(result, "访问秘钥");
          this.key = result.data.msg;
          this.signDataScreenBoxShow = true;
        }
      } catch (error) {
        console.error("获取AccessKey失败：", error);
      }
    },
    //签到码
    handleSignCode(row) {
      this.codeUrl = this.imageUrl + row.sign_in_url;
      this.manageDialogVisible = true;
      this.manageTitle = "签到";
      this.manageTip = "请扫码进入小程序签到";
    },
    //签到数据大屏
    handleSignDataScreen(row) {
      this.currentActivityKey = row.activity_key; // 保存当前活动的 activity_key
      this.DataScreenUrl = row.screenUrl;
      this.fetchActivityCode(row, true); // 传递第二个参数标识是签到大屏
      this._currentUsage(row.activity_key);
    },

    handleVerify(row) {
      // 获取二维码
      this.fetchActivityCode(row);
      this.manageDialogVisible = true;
      this.manageTitle = "核销";
      this.manageTip = "请扫码进入小程序核销";
    },

    // 打开渠道码弹窗
    openChannelCodeDialog(row) {
      const scene = "id=" + row.id + "&st=see&ity=" + row.activity_type;
      getActivityCode({
        activityId: row.id,
        page: "pages/solataireGroupDetails/solitaireGroupDetails",
        scene: scene,
      }).then((res) => {
        if (res.status == 1) {
          this.channelCodeUrl = this.imageUrl + res.data.smallCode;
          this.channelCodeDialogVisible = true;
        }
      });
    },

    // 参与数据同步至投票管家
    openVoteSyncDialog(row) {
      if (!row || !row.id) return;
      const scene = "id=" + row.id + "&st=see&ity=" + row.activity_type;
      getActivityCode({
        activityId: row.id,
        page: "pages/solataireGroupDetails/solitaireGroupDetails",
        scene: scene,
      }).then((res) => {
        if (res.status == 1) {
          this.voteSyncCodeUrl = this.imageUrl + res.data.smallCode;
          this.voteSyncDialogVisible = true;
        }
      });
    },

    // 映射 actions
    ...mapActions("commonData", [
      "success",
      "error",
      "setNickName",
      "saveIsOpenShare",
    ]),
    toPageStatistics(row) {
      this.$router.push({
        path: "/dataStatistics",
        query: { alias: row.activity_key },
      });
    },
    setAdmin(row) {
      // 获取二维码
      this.fetchActivityCode(row);
      this.manageDialogVisible = true;
      this.manageTitle = "设置管理员";
      this.manageTip = "请扫码进入小程序邀请管理员";
    },
    async exportData(row) {
      // 先调用活动详情接口（loginType: 1），status 为 0 时阻止跳转
      try {
        const { msg, status } = await activityDetail({
          activityKey: row.activity_key,
          selectType: "see",
          loginType: 1,
        });
        if (status == 0) {
          this.$message({
            type: "warning",
            message: msg || "获取活动详情失败",
          });
          return;
        }
      } catch (e) {
        console.log("导出前调用活动详情接口失败", e);
      }

      this.$router.push({
        path: "/exportDataPage",
        query: { alias: row.activity_key },
      });
    },

    //补卡
    goSupplementCard(row) {
      this.fetchActivityCode(row);
      this.manageDialogVisible = true;
      this.manageTitle = "补卡";
      this.manageTip = "请扫码进入小程序补卡";
    },
    handleTimeFilterChange(val) {
      console.log(val, "时间筛选下拉");
      this.timeRangeName = val;
      if (val === "自定义") {
        this.showCustomTimePicker = true;
        this.timeRange = 0;
      } else {
        if (val == "全部") {
          this.timeRange = "";
        }
        if (val == "近一个月") {
          this.timeRange = 1;
        }
        if (val == "近三个月") {
          this.timeRange = 3;
        }
        if (val == "近六个月") {
          this.timeRange = 6;
        }
        if (val == "近一年") {
          this.timeRange = 12;
        }
        this.showCustomTimePicker = false;
        this.handleSearch();
      }
    },
    handleCustomTimeChange(e) {
      if (Array.isArray(e) && e.length === 2) {
        this.startTime = e[0];
        this.endTime = e[1];
        this.handleSearch();
      } else {
        console.error("Invalid date range:", e);
        this.startTime = "";
        this.endTime = "";
      }
    },
    handleSearch() {
      // 搜索逻辑
      this.tablePage.pageNum = 1;
      this.getCreateList();
      this.initLogoButtons();
    },
    handleReset() {
      this.searchName = "";
      this.activityType = "";
      this.timeRange = "";
      this.customTimeRange = [];
      this.timeRangeName = "全部";
      this.startTime = "";
      this.endTime = "";
      this.activeState = "";
      this.isDraft = "";
      this.showCustomTimePicker = false;
      this.tablePage.pageNum = 1;
      this.getCreateList();
      this.initLogoButtons();
    },
    batchEditFolder() {
      // 进入批量编辑模式
      this.batchEditMode = true;
      this.selectedRows = [];
    },
    // 行点击事件
    handleRowClick(row) {
      if (row.is_draft == 1 && row.is_draft) {
        return this.dropdownSet(row);
      }
      if (this.batchEditMode) {
        console.log("点击了行", row);
        // 在批量编辑模式下，切换选中状态
        const index = this.selectedRows.indexOf(row.id);
        if (index > -1) {
          // 如果已经选中，则取消选中
          this.selectedRows.splice(index, 1);
        } else {
          // 如果未选中，则添加到选中列表
          this.selectedRows.push(row.id);
        }
      } else {
        this.handleRowNavigation(row);
      }
    },
    // 点击名称：普通活动在新窗口打开活动详情；草稿/信息查询/批量编辑沿用行点击行为
    nameClick(row) {
      if (
        this.batchEditMode ||
        (row.is_draft == 1 && row.is_draft) ||
        row.activity_type == 303
      ) {
        return this.handleRowClick(row);
      }
      const routeData = this.$router.resolve({
        path: "/activityDetails",
        query: { alias: row.activity_key },
      });
      window.open(routeData.href, "_blank");
    },
    // 新增方法以处理行导航的逻辑
    handleRowNavigation(row) {
      if (row.is_folder) {
        // 跳转到文件夹详情页，带上文件夹id
        this.$router.push({
          path: "/folderDetails",
          query: {
            folderId: row.id,
            folderName: row.folderName,
            batchEditMode: this.batchEditMode,
          },
        });
      } else {
        this.navigateToActivity(row);
      }
    },
    navigateToActivity(row) {
      if (row.activity_type == 201) {
        // 跳转到活动详情页，带上活动key
        this.$router.push({
          path: "/activityDetails",
          query: { alias: row.activity_key },
        });
      } else if (row.activity_type == 303) {
        this.fetchActivityCode(row);
        this.manageDialogVisible = true;
        this.manageTitle = row.name;
        this.manageTip = "请扫码进入小程序查看";
      } else {
        // 跳转到活动详情页，带上活动key
        this.$router.push({
          path: "/activityDetails",
          query: { alias: row.activity_key },
        });
      }
    },
    handleSelectionChange(val) {
      console.log(val, "选中的行");
      this.selectedRows = val.map((item) => item.id);
      console.log(this.selectedRows, "选中的文件啊");
    },
    // 批量删除
    batchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请选择需要删除的活动");
        return;
      }
      this.$confirm("确定将所选活动放入回收站吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delTooActivity({
          activityIds: this.selectedRows,
        })
          .then((res) => {
            console.log(res, "删除接口");
            if (res.status === 1) {
              this.$message({
                type: "success",
                message: "成功!",
              });
            } else {
              this.$message.error(res.msg || "删除失败");
            }
            this.getCreateList();
            this.initLogoButtons();
          })
          .catch((err) => {
            this.$message.error(err || "删除失败");
            this.getCreateList();
          });
      });
    },
    //批量移动
    async batchMove() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请选择要移动的活动");
        return;
      }
      // 打开弹窗并拉取文件夹列表
      this.moveDialogVisible = true;
      const res = await allFolder({ userId: localStorage.getItem("userID") });
      if (res.status === 1) {
        this.folderList = res.data;
        console.log(this.folderList, "文件夹列表");
      }
    },
    async confirmMove() {
      // 如果是新建文件夹，先走创建文件夹接口
      if (this.moveType === 1) {
        const res = await create({ folderName: this.folderName });
        if (res.status === 1) {
          this.moveFolderId = res.data.id;
        } else {
          this.$message.error("新建文件夹失败");
          return;
        }
      }
      if (!this.moveFolderId && this.moveType === 2) {
        this.$message.warning("请选择目标文件夹");
        return;
      }
      // TODO: 执行批量移动逻辑
      creFolderActivityByAcid({
        activityIds: this.selectedRows,
        folderId: this.moveFolderId,
      }).then((res) => {
        console.log(res, "移动接口");
        this.$message({
          type: "success",
          message: "成功!",
        });
        this.getCreateList();
        this.initLogoButtons();
      });
      this.moveDialogVisible = false;
    },
    selectableRow(row) {
      // 只有非文件夹行可选
      return !row.is_folder;
    },
    deleteFolder(row) {
      this.$confirm("删除后文件夹里的活动将会转移到我发布的页", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        folderDetete({
          id: row.id,
        }).then((res) => {
          console.log(res, "删除接口");
          this.$message({
            type: "success",
            message: "成功!",
          });
          this.getAllFolderList();
        });
      });
    },
    renameFolder(row) {
      this.folderName = row.folderName;
      this.showCreateFolderDialog = true;
      this.foldertype = 2;
      this.currentFolderID = row.id;
    },
    closeCreateFolderDialog() {
      console.log("hhhh");
      this.showCreateFolderDialog = false;
      this.folderName = "";
      this.currentFolderID = "";
      this.foldertype = 1;
    },
    // 新建文件夹方法
    async createFolder() {
      // 判断输入框是否为空或全是空格
      if (!this.folderName.trim()) {
        this.$message.warning("请输入文件夹名称");
        return;
      }
      // 调用创建文件夹接口
      try {
        // 调用API创建文件夹，传递文件夹名称
        if (this.foldertype == 1) {
          const res = await create({ folderName: this.folderName });
          if (res.status === 1) {
            // 创建成功，提示并关闭弹窗，清空输入框，刷新列表
            this.$message.success("创建成功");
            this.showCreateFolderDialog = false;
            this.folderName = "";
            this.getAllFolderList();
          }
        } else {
          const res = await update({
            folderName: this.folderName,
            id: this.currentFolderID,
          });
          if (res.status === 1) {
            this.$message.success("重命名成功");
            this.getAllFolderList();
          }
          // 关闭弹窗并清空输入
          this.showCreateFolderDialog = false;
          this.folderName = "";
          this.currentFolderID = "";
          this.foldertype = 1;
        }
      } catch (e) {
        // 接口异常，提示失败
        this.$message.error("创建失败");
      }
    },
    async getAllFolderList() {
      const result = await allFolder({
        userId: localStorage.getItem("userID"),
      });
      if (result.status == 1) {
        // 只更新文件夹部分，保留原有活动数据
        const folderList = result.data.map((item) => ({
          ...item,
          is_folder: true,
        }));
        // 保留原有活动数据（非文件夹）
        const activityList = this.tableData.filter((item) => !item.is_folder);
        this.tableData = [...folderList, ...activityList];
      }
    },
    handleTagClick(val) {
      this.activeTag = val;
      this.recordType = val;
      console.log(val, "活动类型");
      if (this.recordType == 3) {
        this.handleSelBrowseHistory();
      } else {
        this.handleReset();
        this.getCreateList();
        this.initLogoButtons();
      }
    },
    filterHandler(value, row) {
      console.log(value, row);
    },
    handleSizeChange(pageSize) {
      this.tablePage.pageNum = 1;
      this.tablePage.pageSize = pageSize;
      this.getCreateList();
      this.initLogoButtons();
    },
    handlePageChange(currentPage) {
      this.tablePage.pageNum = currentPage;
      this.getCreateList();
      this.initLogoButtons();
    },

    // 是否「仅统计不收费」收费报名（paymentSwitch=2；后端可能返回字符串或下划线字段，宽松判断）
    isStatisticsOnly(item) {
      return item.paymentSwitch == 2 || item.payment_switch == 2;
    },

    //切换类型

    activityBigTypeChange() {
      if (this.recordType == 3) {
        this.handleSelBrowseHistory();
      } else {
        this.getCreateList();
        this.initLogoButtons();
      }
    },
    statusOptionsChange(val) {
      console.log(val, "val接龙状态啊");
      this.activeStateName = val;
      if (val === "草稿") {
        this.isDraft = 1;
        this.activeState = "";
      } else {
        this.isDraft = 0;
        if (val === "全部") {
          this.activeState = "";
        } else if (val === "进行中") {
          this.activeState = 1;
        } else if (val === "未开始") {
          this.activeState = 3;
        } else if (val === "已结束") {
          this.activeState = 2;
        }
      }
      if (this.recordType == 3) {
        this.handleSelBrowseHistory();
      } else {
        this.getCreateList();
        this.initLogoButtons();
        // this.handleReset();
      }
    },

    // 切换时间排序

    sortTypeChange() {
      if (this.recordType == 3) {
        this.handleSelBrowseHistory();
      } else {
        this.getCreateList();
        this.initLogoButtons();
        this.handleReset();
      }
    },

    //我的浏览
    async handleSelBrowseHistory() {
      await selBrowseHistory({
        activityBigType: "",
        recordType: this.recordType,
        orderType: this.sortType,
        activityType: this.activityType,
        activeState: this.isDraft == 0 ? this.activeState : "", // 传递状态
        isDraft: this.isDraft, // 草稿
        timeRange: this.timeRange,
        activityName: this.searchName,
        startTime: this.startTime,
        endTime: this.endTime,
      }).then((res1) => {
        // let activityList = [];
        this.tableData = res1.data.map((item) => {
          return {
            activity_big_type: item.activityBigType,
            active_state: item.activeState,
            id: item.activityId,
            activity_key: item.activityKey,
            name: item.activityName,
            activity_type: item.activityType,
            payment_switch:
              item.paymentSwitch != null
                ? item.paymentSwitch
                : item.payment_switch,
            user_id: item.userId,
            is_it_over: item.isItOver,
            add_time: item.addTime,
            begin_time: item.beginTime,
            end_time: item.endTime,
          };
        });
        console.log(this.tableData, "this.tableData");
        // 数据加载完成后更新页面标题
        this.setPageTitle();
      });
    },
    getCreateList() {
      // 签到打卡
      // 第一个接口：获取活动列表
      getCreateList({
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.pageNum,
        activityBigType: "",
        recordType: this.recordType,
        sortType: this.sortType,
        activityType: this.activityType,
        activeState: this.isDraft == 0 ? this.activeState : "", // 传递状态
        isDraft: this.isDraft, // 草稿
        timeRange: this.timeRange,
        activityName: this.searchName,
        startTime: this.startTime,
        endTime: this.endTime,
      }).then((res1) => {
        let activityList = [];
        if (res1.status == 1) {
          activityList = res1.data.list;
        }
        this.tablePage.total = res1.data.total;

        // 只有"我的发布"才显示文件夹
        if (this.recordType == 1) {
          allFolder({ userId: localStorage.getItem("userID") }).then((res2) => {
            let folderList = [];
            if (res2.status == 1) {
              // 给文件夹数据加上 is_folder 标记
              folderList = res2.data.map((item) => ({
                ...item,
                is_folder: true,
              }));
            }
            // 合并数据，文件夹排在前面
            this.tableData = [...folderList, ...activityList];
            console.log(this.tableData, "this.tableData");
          });
        } else {
          // 不是"我的发布"时，只显示活动
          this.tableData = activityList;
          console.log(this.tableData, "this.tableData");
        }

        // 如果从创建页来
        if (this.isOpenShare) {
          this.loadingShow = this.$loading({
            lock: true,
            text: "加载中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          setTimeout(() => {
            const firstNonFolderItem = this.tableData.find(
              (item) => !item.is_folder,
            );
            if (firstNonFolderItem) {
              this.shareClick(firstNonFolderItem);
            }
            this.saveIsOpenShare(false);
            this.loadingShow.close();
          }, 1100);
        }
      });
    },

    //展示分享弹窗
    shareClick(row) {
      console.log(row, "row");
      this.JumpUrl = "";
      // 重置自定义 Logo 状态
      this.logoText = "";
      this.logoTextDisplay = "";
      this.selectedColorIndex = -1;
      this.agreementChecked = false;
      this.showCustomInput = false;
      this.canvasCodeUrl = "";

      if (row.is_folder) {
        this.shareTitle = "分享" + "    " + "    " + "    " + row.folderName;
      } else {
        this.shareTitle = "分享" + "    " + "    " + "    " + row.name;
      }

      if (row.activity_big_type == 2) {
        this.faceUrl =
          "/pages-mine/previewTemplate/previewTemplate?alias=" +
          row.activity_key +
          "&selectType=see&isType=" +
          row.activity_type;
      } else if (row.activity_big_type == 1 && row.activity_type != 108) {
        this.faceUrl =
          "/pages/solataireGroupDetails/solataireGroupDetails?alias=" +
          row.activity_key +
          "&selectType=see&isType=" +
          row.activity_type;
      } else if (row.activity_big_type == 3) {
        this.faceUrl =
          "/pages-mine/poster/poster?alias=" +
          row.activity_key +
          "&selectType=see";
      } else if (row.activity_type == 108) {
        this.faceUrl =
          "/pages-mine/solitaireDetails/solitaireDetails?alias=" +
          row.activity_key +
          "&selectType=see&isType=" +
          row.activity_type;
      }
      // 获取二维码
      this.fetchActivityCode(row);
      this.dialogVisible = true;
    },

    // 获取二维码

    fetchActivityCode(row, isSignDataScreen = false) {
      console.log(row, "信息呢-activity_type");

      if (!row.is_folder) {
        // 信息查询（303）扫码进入独立小程序页，scene 用 from=qr 标记来源
        const isInfoCheck = row.activity_type == 303;
        const scene = isInfoCheck
          ? "id=" + row.id + "&st=see&from=qr"
          : "id=" + row.id + "&st=see&ity=" + row.activity_type;
        getActivityCode({
          activityId: row.id,
          page: isInfoCheck
            ? "pages-second/informationCheckingIndex/informationCheckingIndex"
            : "pages/solataireGroupDetails/solataireGroupDetails",
          scene: scene,
        }).then((res) => {
          if (res.status == 1) {
            this.codeUrl = this.imageUrl + res.data.smallCode;
            this.canvasCodeUrl = this.imageUrl + res.data.smallCode;
            // 获取到二维码后，渲染 Canvas
            this.$nextTick(() => {
              this.renderCanvas();
            });
            // 只有点击签到大屏时才调用_getAccessKey
            if (isSignDataScreen && row.sign_in_switch == 2) {
              this._getAccessKey(row);
            }
          }
        });

        getShareLink({ activityId: row.id }).then((res) => {
          if (res.status == 1) {
            this.JumpUrl = res.data.shareLink;
          }
        });
      } else {
        const scene = this.generateSceneParam(row.id, row.folderName);
        getFolderShareLink({
          activityId: row.id,
          page: "pages-views/folderDetail/folderDetail",
          scene: scene,
        }).then((res) => {
          if (res.status == 1) {
            this.codeUrl = this.imageUrl + res.data.smallCode;
            this.canvasCodeUrl = this.imageUrl + res.data.smallCode;
            // 获取到二维码后，渲染 Canvas
            this.$nextTick(() => {
              this.renderCanvas();
            });
          }
        });
      }

      if (
        this.loadingShow &&
        typeof this.loadingShow === "object" &&
        typeof this.loadingShow.close === "function"
      ) {
        this.loadingShow.close();
      }
    },

    generateSceneParam(id, folderName) {
      const text = folderName.trim().slice(0, 10); // 强制10个中文
      const idStr = String(id).trim(); // 不限制id长度，动态适配

      const gbkBuffer = iconvLite.encode(text, "gbk");

      const compressed = pako.deflateRaw(gbkBuffer, {
        level: 9, // 最高压缩级别
        memLevel: 9, // 最大内存占用，压缩率拉满（中文压缩率≥25%）
      });
      const nEncoded = btoa(String.fromCharCode(...compressed))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");

      const scene = `id=${idStr}&n=${nEncoded}`;
      return scene;
    },

    // 自定义 Logo 相关方法
    enableCustomInput() {
      this.showCustomInput = true;
      this.logoText = "";
      this.isDefaultMode = false;
      this.agreementChecked = false;
      this.$nextTick(() => {
        this.renderCanvas();
      });
    },
    setLogoText(text) {
      this.logoText = text;
      this.showCustomInput = false;
      // 如果文字等于默认文字，则是默认模式
      this.isDefaultMode = text === this.defaultLogoText;
      // 切换到默认模式时重置颜色索引和协议勾选状态
      if (this.isDefaultMode) {
        this.selectedColorIndex = -1;
      }
      this.agreementChecked = false;
      this.$nextTick(() => {
        this.renderCanvas();
      });
    },
    handleLogoTextChange() {
      this.$nextTick(() => {
        this.renderCanvas();
      });
    },
    selectColor(index) {
      this.selectedColorIndex = index;
      // 如果当前没有文字，设置为默认文字
      if (!this.logoText) {
        this.logoText = this.defaultLogoText;
      }
      // 选择颜色表示用户进行了自定义修改，需要退出默认模式
      this.isDefaultMode = false;
      this.agreementChecked = false;
      this.$nextTick(() => {
        this.renderCanvas();
      });
    },

    // 使用 Canvas 渲染带 Logo 的二维码（预览 + 下载）
    renderCanvas() {
      const canvas = this.$refs.logoCanvas;
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      // 使用 2 倍分辨率，保证在高 DPI 屏幕上清晰显示
      const dpr = window.devicePixelRatio || 1;
      const displaySize = 300; // 显示尺寸
      const size = Math.round(displaySize * dpr); // 画布实际尺寸
      canvas.width = size;
      canvas.height = size;
      // 保持 CSS 显示尺寸不变
      canvas.style.width = displaySize + "px";
      canvas.style.height = displaySize + "px";
      // 缩放绘图上下文以匹配设备像素比
      ctx.scale(dpr, dpr);

      // 如果没有二维码 URL，不渲染
      if (!this.canvasCodeUrl) return;

      // 创建二维码图像
      const qrImg = new Image();
      qrImg.crossOrigin = "Anonymous";
      qrImg.src = this.canvasCodeUrl;

      qrImg.onload = () => {
        try {
          // 绘制白色背景
          ctx.fillStyle = "#FFFFFF";
          ctx.fillRect(0, 0, displaySize, displaySize);

          // 绘制二维码
          ctx.drawImage(qrImg, 0, 0, displaySize, displaySize);

          // 绘制中心圆形 Logo 区域
          // 条件：有文字（包括默认模式）
          if (this.logoText) {
            // 绘制中心圆形 Logo 区域
            const centerX = displaySize / 2;
            const centerY = displaySize / 2;
            const logoRadius = 68; // Logo 半径

            // 创建圆形裁剪区域
            ctx.save();
            ctx.beginPath();
            ctx.arc(centerX, centerY, logoRadius, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.clip();

            // 绘制彩色圆形背景（完全覆盖中心区域）
            const bgColor =
              this.selectedColorIndex >= 0
                ? this.logoColors[this.selectedColorIndex]
                : this.defaultLogoColor;
            ctx.fillStyle = bgColor;
            ctx.beginPath();
            ctx.arc(centerX, centerY, logoRadius, 0, Math.PI * 2, true);
            ctx.fill();

            // 只有在有文字时才绘制文字
            if (this.logoText) {
              // 绘制自定义文字
              ctx.fillStyle = "#FFFFFF"; // 文字颜色固定为白色
              ctx.textAlign = "center";
              ctx.textBaseline = "middle";

              const len = this.logoText.length;
              if (len <= 2) {
                // 1-2 个字，单排
                ctx.font = 'bold 50px "庞门正道标题体", Arial';
                ctx.fillText(this.logoText, centerX, centerY + 5);
              } else if (len == 3) {
                ctx.font = 'bold 40px "庞门正道标题体", Arial';
                ctx.fillText(this.logoText, centerX, centerY + 5);
              } else {
                // 超过 2 个字，两排，每排 2 个
                ctx.font = 'bold 36px "庞门正道标题体", Arial';
                const lineHeight = 40;
                const firstRow = this.logoText.slice(0, 2);
                const secondRow = this.logoText.slice(2, 4);
                ctx.fillText(firstRow, centerX, centerY - lineHeight / 2 + 5);
                ctx.fillText(secondRow, centerX, centerY + lineHeight / 2 + 5);
              }
            }

            ctx.restore();
          }
        } catch (error) {
          // 静默处理错误
        }
      };

      qrImg.onerror = () => {
        // 静默处理错误
      };
    },

    // 下载 Canvas 图片
    downloadCanvasImage() {
      const canvas = this.$refs.logoCanvas;
      if (!canvas) {
        this.$message.error("Canvas 未准备好");
        return;
      }

      try {
        // 导出高分辨率图片
        const tempCanvas = document.createElement("canvas");
        const tempCtx = tempCanvas.getContext("2d");
        const highResSize = 600; // 高分辨率
        tempCanvas.width = highResSize;
        tempCanvas.height = highResSize;

        // 重新绘制高分辨率版本
        const qrImg = new Image();
        qrImg.crossOrigin = "Anonymous";
        qrImg.src = this.canvasCodeUrl;

        qrImg.onload = () => {
          // 绘制白色背景
          tempCtx.fillStyle = "#FFFFFF";
          tempCtx.fillRect(0, 0, highResSize, highResSize);

          // 绘制二维码
          tempCtx.drawImage(qrImg, 0, 0, highResSize, highResSize);

          // 只有在有自定义文字时才绘制中心圆形 Logo
          if (this.logoText) {
            const centerX = highResSize / 2;
            const centerY = highResSize / 2;
            const logoRadius = 136;

            // 创建圆形裁剪区域
            tempCtx.save();
            tempCtx.beginPath();
            tempCtx.arc(centerX, centerY, logoRadius, 0, Math.PI * 2, true);
            tempCtx.closePath();
            tempCtx.clip();

            // 绘制彩色圆形背景（完全覆盖中心区域）
            const bgColor =
              this.selectedColorIndex >= 0
                ? this.logoColors[this.selectedColorIndex]
                : this.defaultLogoColor;
            tempCtx.fillStyle = bgColor;
            tempCtx.beginPath();
            tempCtx.arc(centerX, centerY, logoRadius, 0, Math.PI * 2, true);
            tempCtx.fill();

            // 绘制文字
            tempCtx.fillStyle = "#FFFFFF"; // 文字颜色固定为白色
            tempCtx.textAlign = "center";
            tempCtx.textBaseline = "middle";

            const len = this.logoText.length;
            if (len <= 2) {
              tempCtx.font = 'bold 100px "庞门正道标题体", Arial';
              tempCtx.fillText(this.logoText, centerX, centerY + 10);
            } else if (len == 3) {
              tempCtx.font = 'bold 80px "庞门正道标题体", Arial';
              tempCtx.fillText(this.logoText, centerX, centerY + 10);
            } else {
              // 超过 3 个字，两排，每排 2 个
              tempCtx.font = 'bold 72px "庞门正道标题体", Arial';
              const lineHeight = 80;
              const firstRow = this.logoText.slice(0, 2);
              const secondRow = this.logoText.slice(2, 4);
              tempCtx.fillText(
                firstRow,
                centerX,
                centerY - lineHeight / 2 + 10,
              );
              tempCtx.fillText(
                secondRow,
                centerX,
                centerY + lineHeight / 2 + 10,
              );
            }

            tempCtx.restore();
          }

          // 下载
          const dataUrl = tempCanvas.toDataURL("image/png");
          this.downloadIamge(dataUrl, "接龙二维码_" + new Date().valueOf());
        };

        qrImg.onerror = () => {
          // 图片加载失败，静默处理
        };
      } catch (error) {
        // 静默处理错误
      }
    },

    downloadIamge(imgsrc, name) {
      // 下载图片地址和图片名
      if (!imgsrc) {
        return;
      }

      // 如果是 base64 数据，直接下载
      if (imgsrc.startsWith("data:image")) {
        try {
          var a = document.createElement("a");
          a.download = name || "photo";
          a.href = imgsrc;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          return;
        } catch (error) {
          // 静默处理错误
        }
      }

      var image = new Image();

      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "Anonymous");

      image.onload = () => {
        try {
          var canvas = document.createElement("canvas");

          canvas.width = image.width;

          canvas.height = image.height;

          var context = canvas.getContext("2d");

          context.fillStyle = "#FFFFFF";

          context.fillRect(0, 0, canvas.width, canvas.height);

          context.drawImage(image, 0, 0, image.width, image.height);

          var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据

          var a = document.createElement("a"); // 生成一个a元素

          a.download = name || "photo"; // 设置图片名称

          a.href = url; // 将生成的URL设置为a.href属性

          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } catch (error) {
          // 静默处理错误
        }
      };

      image.onerror = () => {
        // 静默处理错误
      };

      image.src = imgsrc;
    },

    // 编辑修改

    dropdownSet(row) {
      console.log(row, "去编辑--内容");
      console.log(row.createId != row.user_id);
      console.log(row.is_admin == 2);

      if ((row.createId && row.createId != row.user_id) || row.is_admin == 2) {
        this.$message("没有权限修改");
        return false;
      }
      // this.$router.push({
      //   path: "/solitaire",
      //   query: {
      //     activityId: row.id,
      //     selectType: "update",
      //     isType: row.activity_type,
      //   },
      // });

      if (row.activity_big_type == 2) {
        const routeData = this.$router.resolve({
          path: "/solitaire",
          query: {
            alias: row.activity_key,
            selectType: "update",
            isType: row.activity_type,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        if (row.activity_type == 303) {
          this.fetchActivityCode(row);
          this.manageDialogVisible = true;
          this.manageTitle = "编辑";
          this.manageTip = "请扫码进入小程序活动详情进行修改";
        } else {
          const routeData = this.$router.resolve({
            path: "/solitaire",
            query: {
              alias: row.activity_key,
              selectType: "update",
              isType: row.activity_type,
            },
          });
          window.open(routeData.href, "_blank");
        }
      }
    },

    // 提前结束

    dropdownEnd(row) {
      var toastMessage = "";

      if (row.active_state == 1) {
        // 活动未开始

        toastMessage = "是否立即开始该活动";
      } else if (row.active_state == 2) {
        // 活动已结束

        toastMessage = "是否立即重启该活动";
      } else if (row.active_state == 3) {
        // 活动进行中

        toastMessage = "是否提前结束该活动";
      }

      this.$confirm(toastMessage, "提示", {
        confirmButtonText: "确定",

        cancelButtonText: "取消",

        type: "warning",
      })

        .then(() => {
          if (row.active_state == 1) {
            // 活动未开始

            startImmediately({
              id: row.id,
            }).then((res) => {
              console.log(res, "立即开始接口");

              this.$message({
                type: "success",

                message: "成功!",
              });

              this.getCreateList();
              this.initLogoButtons();
            });

            // earlyTermination,restartActivity,startImmediately
          } else if (row.active_state == 2) {
            // 活动已结束

            restartActivity({
              id: row.id,
            }).then((res) => {
              console.log(res, "重启活动接口");

              this.$message({
                type: "success",

                message: "成功!",
              });

              this.getCreateList();
              this.initLogoButtons();
            });
          } else if (row.active_state == 3) {
            // 活动进行中

            console.log("提前结束接口");

            earlyTermination({
              id: row.id,
              is_it_over: 2,
              userId: localStorage.getItem("userID"),
            }).then((res) => {
              console.log(res, "提前结束接口");
              this.$message({
                type: "success",
                message: "成功!",
              });
              this.getCreateList();
              this.initLogoButtons();
            });
          }
        })
        .catch(() => {});
      console.log(row, "row");
    },

    // 复制
    dropdownCopy(row) {
      console.log(row, "row");
      // 根据活动类型跳转到不同页面
      if (row.activity_big_type == 2) {
        // 通知公告类型
        this.$router.push({
          path: "/solitaire",
          query: {
            alias: row.activity_key,
            selectType: "add",
            isType: row.activity_type,
            copy: true,
          },
        });
      } else if (row.activity_type == 303) {
        // 特殊类型303，需要扫码编辑
        this.fetchActivityCode(row);
        this.manageDialogVisible = true;
        this.manageTitle = "复制";
        this.manageTip = "请扫码进入小程序复制活动";
      } else {
        // 通用接龙类型
        // const routeData = this.$router.resolve({
        //   path: "/solitaire",
        //   query: {
        //     alias: row.activity_key,
        //     selectType: "add",
        //     isType: row.activity_type,
        //     copy: true,
        //   },
        // });
        // window.open(routeData.href, "_blank");
        this.$router.push({
          path: "/solitaire",
          query: {
            alias: row.activity_key,
            selectType: "add",
            isType: row.activity_type,
            copy: true,
          },
        });
      }
    },
    // 清空数据
    dropdownResetData(row) {
      console.log(row, "row");
      this.$confirm(
        "确认清空全部参与记录吗？确认后将无法恢复，请谨慎操作。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        delSignOrder({
          activityId: row.id,
        })
          .then((res) => {
            console.log(res, "清空接口");
            this.$message({
              type: "success",
              message: "成功!",
            });
            this.getCreateList();
            this.initLogoButtons();
          })
          .catch(() => {});
      });
    },
    // 删除

    dropdownDel(row) {
      console.log(row, "row");
      if (row.is_draft == 1 && row.is_draft) {
        this.$confirm("确定删除该草稿吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            delActivity({
              activityId: row.id,
            }).then((res) => {
              console.log(res, "删除接口");
              this.$message({
                type: "success",
                message: "成功!",
              });

              this.getCreateList();
              this.initLogoButtons();
            });
          })

          .catch(() => {
            this.$message({
              type: "success",
              message: "取消删除!",
            });
          });
      } else {
        if (row.active_state == 2) {
          this.$confirm("确定删除该活动吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              delActivity({
                activityId: row.id,
              }).then((res) => {
                console.log(res, "删除接口");
                this.$message({
                  type: "success",
                  message: "成功!",
                });

                this.getCreateList();
                this.initLogoButtons();
              });
            })

            .catch(() => {});
        } else {
          this.$confirm("是否立即结束当前活动，并删除活动？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              earlyTermination({
                id: row.id,
                is_it_over: 2,
                userId: localStorage.getItem("userID"),
              }).then((res) => {
                delActivity({
                  activityId: row.id,
                }).then((res) => {
                  console.log(res, "删除接口9999");
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });

                  this.getCreateList();
                  this.initLogoButtons();
                });
              });
            })
            .catch(() => {});
        }
      }
    },
    dropdownTransfer(row) {
      this.fetchActivityCode(row);
      this.manageDialogVisible = true;
      this.manageTitle = "转让项目";
      this.manageTip = "请扫码进入小程序转让项目";
    },
    copyClick(sender) {
      var input = document.createElement("input"); // 创建input对象

      input.value = sender; // 设置复制内容

      document.body.appendChild(input); // 添加临时实例

      input.select(); // 选择实例内容

      document.execCommand("Copy"); // 执行复制

      document.body.removeChild(input); // 删除临时实例

      this.$message.success("复制成功！");
    },

    // 操作列「查看」：文件夹→文件夹详情（与点击文件夹名一致）；其他活动→报名列表，均在原窗口打开
    viewItem(row) {
      if (row.is_folder) {
        this.handleRowNavigation(row);
        return;
      }
      this.joinClick(row);
    },
    joinClick(sender) {
      console.log(sender);
      if (this.recordType === 4) {
        return false;
      }

      this.$router.push({
        path: "/joinList",
        query: { alias: sender.activity_key, activityName: sender.name },
      });
    },

    clickHandler(event) {
      this.isAcive = event.target.innerText;
    },

    // 打开红包设置
    openRedPacketDialog(row) {
      this.fetchActivityCode(row);
      this.manageDialogVisible = true;
      this.manageTitle = "红包设置";
      this.manageTip = "请扫码进入小程序设置红包";
    },

    // 获取红包列表
    getRedPacketListData(activityId) {
      const params = {
        activityId: activityId,
        pageNum: this.redPacketPageNum,
        pageSize: this.redPacketPageSize,
      };
      getRedPacketList(params)
        .then((res) => {
          console.log("红包列表数据:", res);
          if (res.status === 1 || res.code === 200 || res.code === 0) {
            this.redPacketList = res.data.list || [];
          }
        })
        .catch((error) => {
          console.error("获取红包列表失败:", error);
        });
    },

    // 打开添加红包弹窗
    openAddRedPacketDialog() {
      // 关闭支付二维码弹窗
      this.paymentQrcodeDialogVisible = false;
      // 关闭红包设置弹窗
      this.redPacketDialogVisible = false;
      this.redPacketForm = {
        probability: "",
        name: "",
        type: 1,
        singleAmount: "",
        totalAmount: "",
        minimumAmount: "",
        maximumAmount: "",
        redEnvelopesNumber: "",
        lotteryRuleType: 1,
      };
      this.redPacketCalculatedPrice = null;
      this.addRedPacketDialogVisible = true;
    },

    // 计算红包价格
    async calculatePrice() {
      const amount =
        this.redPacketForm.type === 1
          ? this.redPacketForm.singleAmount
          : this.redPacketForm.totalAmount;

      if (!amount || amount <= 0) {
        this.redPacketCalculatedPrice = null;
        return;
      }

      // 红包个数必须填写
      if (
        !this.redPacketForm.redEnvelopesNumber ||
        this.redPacketForm.redEnvelopesNumber <= 0
      ) {
        this.redPacketCalculatedPrice = null;
        return;
      }

      try {
        const params = {
          packetType: this.redPacketForm.type,
          packetCount: this.redPacketForm.redEnvelopesNumber,
        };

        // 根据红包类型传递不同参数
        if (this.redPacketForm.type === 1) {
          params.singleAmount = this.redPacketForm.singleAmount;
        } else {
          params.totalAmount = this.redPacketForm.totalAmount;
        }

        const res = await calculateRedPacketPrice(params);
        console.log("计算红包价格响应:", res);
        // 兼容多种响应格式
        if (res.status === 1 || res.code === 200 || res.code === 0) {
          this.redPacketCalculatedPrice = res.data.totalAmount;
        }
      } catch (error) {
        console.error("计算红包价格失败:", error);
      }
    },

    // 提交红包
    async submitRedPacket() {
      try {
        await this.$refs.redPacketFormRef.validate();
      } catch (error) {
        return;
      }

      this.redPacketSubmitting = true;

      try {
        // 调用创建红包接口（直接返回二维码）
        const orderParams = {
          activityId: this.currentRedPacketRow.id,
          probability: this.redPacketForm.probability,
          senderName: this.redPacketForm.name,
          packetType: this.redPacketForm.type,
          totalAmount:
            this.redPacketForm.type === 1 ? "" : this.redPacketForm.totalAmount,
          singleAmount:
            this.redPacketForm.type === 1
              ? this.redPacketForm.singleAmount
              : "",
          packetCount: this.redPacketForm.redEnvelopesNumber,
          minAmount: this.redPacketForm.minimumAmount,
          maxAmount: this.redPacketForm.maximumAmount,
          lotteryRuleType: this.redPacketForm.lotteryRuleType,
        };

        const res = await createRedPacketOrderPc(orderParams);
        console.log("创建红包结果:", res);

        if (res.data?.qrCodeBase64) {
          // 显示支付二维码弹窗
          this.paymentQrcode = res.data.qrCodeBase64;
          // 设置支付信息
          this.paymentInfo = {
            amount: res.data.amount || this.redPacketCalculatedPrice || "88.00",
            orderNo: res.data.orderNo || "",
            createTime: this.formatDate(new Date()),
          };
          this.paymentQrcodeDialogVisible = true;
          // 关闭添加红包弹窗
          this.addRedPacketDialogVisible = false;
        } else {
          this.$message.error("红包创建失败，请重试");
        }
      } catch (error) {
        console.error("红包创建失败:", error);
        this.$message.error("红包创建失败，请重试");
      } finally {
        this.redPacketSubmitting = false;
      }
    },

    // 格式化日期时间
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}-${hours}:${minutes}`;
    },

    // 查看红包领取详情
    viewRedPacketDetail(row) {
      console.log("查看红包详情:", row);
      this.currentPacketId = row.packetId;
      this.claimDetailDialogVisible = true;
      this.claimDetailPageNum = 1;
      this.getClaimDetailData();
    },

    // 获取领取详情列表
    getClaimDetailData() {
      const params = {
        packetId: this.currentPacketId,
        pageNum: this.claimDetailPageNum,
        pageSize: this.claimDetailPageSize,
      };
      getClaimDetail(params)
        .then((res) => {
          console.log("领取详情数据:", res);
          if (res.status === 1 || res.code === 200 || res.code === 0) {
            const data = res.data || {};
            this.claimDetailList = data.claimList || [];
            this.claimDetailTotal = data.total || 0;
            // 汇总信息
            this.claimDetailSummary = {
              claimedCount: data.claimedCount || 0, // 已领取个数
              totalCount: data.totalCount || 0, // 总个数
              claimedAmount: data.claimedAmount || 0, // 已领取金额
              totalAmount: data.totalAmount || 0, // 红包总金额
            };
          }
        })
        .catch((error) => {
          console.error("获取领取详情失败:", error);
        });
    },
  },
  beforeDestroy() {
    // 清除支付检查定时器
    if (this.paymentCheckTimer) {
      clearInterval(this.paymentCheckTimer);
      this.paymentCheckTimer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-date-editor .el-range-separator {
  width: 12%;
}
::v-deep .el-date-editor .el-range-separator {
  line-height: 30px !important;
  height: 30px !important;
}
//::v-deep .el-input--suffix .el-input__inner {
// padding-right: 75px !important;
//}
::v-deep .el-input__icon {
  line-height: 30px !important;
  height: 30px;
}
// dialog 下的分割线
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e7e7e7; /* 添加分割线 */
  padding-bottom: 15px; /* 可选：调整间距 */
  background-color: #fff;
}

.back-view {
  background-color: #ffffff;

  width: 100%;

  min-height: 500px;
  margin-bottom: 50px;
  padding-bottom: 20px;

  // justify-content: center;

  // align-items: center;

  // display: flex;

  // flex-direction: column;

  // overflow: auto;
}

.top-view {
  // height: 30px;
  display: flex;
  padding-top: 10px;
  width: 100%;
  align-items: center;
}
.top-view-search {
  display: flex;
  width: 100%;
  align-items: center;
}
.type-view {
  display: flex;
  width: 100%;
  padding: 10px 20px;
  align-items: center;
  justify-content: space-between;
}

.list-back-view {
  padding-left: 20px;
  padding-right: 20px;
  /*padding-bottom: 15px;*/
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  overflow: visible !important;
  // min-height: 800px;
}

.el-dropdown-link {
  cursor: pointer;

  color: #409eff;

  font-size: 12px;
}

.el-icon-arrow-down {
  font-size: 10px;
}

.demonstration {
  display: block;

  color: #8492a6;

  font-size: 14px;

  margin-bottom: 20px;
}

.radioBack .el-radio-group {
  border-radius: 40px;

  overflow: hidden;

  border: 1px solid #1877ff;
}

.radioBack .el-radio-button {
  // width: 120px;

  margin: 0;
}

.radioBack .el-radio-button__inner {
  color: #1877ff;

  border: #1877ff;

  font-size: 12px;
}

::v-deep .el-radio-button__inner {
  color: rgb(64, 158, 255);
}

.code-image {
  margin-top: 40px;

  width: 200px;

  height: 200px;
}
::v-deep .customer-service-dialog {
  .cs-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    color: #323b5a;
  }
  .cs-dialog-header .el-icon-close {
    cursor: pointer;
    color: #a0a3b1;
    font-size: 18px;
  }
  .cs-dialog-content {
    text-align: center;
    padding: 10px 0 20px;
  }
  .cs-dialog-content img {
    width: 200px;
    height: 200px;
    object-fit: contain;
    margin-bottom: 10px;
  }
  .cs-dialog-content p {
    color: #666;
    font-size: 14px;
    margin: 0;
  }
}

.acStyle {
  width: 120px;

  height: 30px;

  background-color: #1877ff;

  color: white;

  font-size: 12px;

  border: 0;
}

.defStyle {
  width: 120px;

  height: 30px;

  background-color: white;

  color: #1877ff;

  font-size: 12px;

  border: 1px solid #1877ff;
}

.nobegin {
  margin-top: 2px;

  margin-right: 5px;

  margin-left: 15px;

  font-size: 12px;

  line-height: 19px;

  width: 45px;

  height: 19px;

  background: #fff0f0;

  border: 1px solid #feeaea;

  border-radius: 4px;

  color: #f67a7a;
  display: flex;
  justify-content: center;
}

.alreadyend {
  margin-top: 2px;

  margin-right: 5px;

  margin-left: 15px;

  font-size: 12px;

  line-height: 19px;

  width: 45px;

  height: 19px;

  background: #d8d8d8;

  border: 1px solid #d8d8d8;

  border-radius: 4px;

  color: white;
  display: flex;
  justify-content: center;
}

.going {
  margin-top: 2px;

  margin-right: 5px;

  margin-left: 15px;

  font-size: 12px;

  line-height: 19px;

  width: 45px;

  height: 19px;

  background: #1bce4a;

  border: 1px solid #1bce4a;

  border-radius: 4px;

  color: white;
  display: flex;
  justify-content: center;
}

.cgclass {
  margin-top: 2px;
  margin-right: 5px;
  margin-left: 15px;
  font-size: 12px;
  line-height: 19px;
  width: 45px;
  height: 19px;
  background: #fea951;
  border: 1px solid #fea951;
  border-radius: 4px;
  color: white;
  display: flex;
  justify-content: center;
}

.jlclass {
  width: 60px;
  height: 20px;
  background: rgba(81, 111, 240, 0.16);
  border: 1px solid rgba(81, 111, 240, 0.11);
  border-radius: 4px;
  color: #516ff0;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dkclass {
  width: 60px;
  height: 20px;
  background: rgba(85, 167, 253, 0.16);
  border: 1px solid rgba(85, 167, 253, 0.11);
  border-radius: 4px;
  color: #1877ff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.tzclass {
  width: 60px;
  height: 20px;
  background: rgba(27, 206, 74, 0.16);
  border: 1px solid rgba(27, 206, 74, 0.11);
  border-radius: 4px;
  color: #1bce4a;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.hyclass {
  width: 60px;
  height: 20px;
  background: rgba(107, 27, 206, 0.16);
  border: 1px solid rgba(107, 27, 206, 0.11);
  border-radius: 4px;
  color: #6b1bce;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.sfclass {
  width: 60px;
  height: 20px;
  background: #ffede2;
  border-radius: 4px;
  color: #f98849;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  border: 1px solid rgba(249, 136, 73, 0.11);
}
.bmclass {
  width: 60px;
  height: 20px;
  background: rgb(33 202 86 / 20%);
  border-radius: 4px;
  color: #29bc7c;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  border: 1px solid rgba(41, 188, 124, 0.11);
}
.wzClass {
  overflow: auto;
  height: 439px;
  // text-align: center;
  justify-content: center;
  // display: flex;
  // flex-direction: column;
  padding-left: 27px;
  margin-top: 10px;
}
.createFloderClass {
  cursor: pointer;
  width: 128px;
  height: 30px;
  border: 1px solid #1877ff;
  border-radius: 4px;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  color: #1877ff;
  line-height: 30px;
}
.folder-radio-group .folder-radio-item {
  display: flex;
  align-items: center;
  height: 38px;
  padding: 0 8px;
  border-radius: 4px;
  margin-bottom: 6px;
  transition: background 0.2s;
  border-bottom: 1px solid #ececec;
}
.folder-radio-group .folder-radio-item:last-child {
  border-bottom: none; /* 最后一项不显示下划线 */
}
.folder-radio-group .folder-radio-item:hover {
  background: #f5f7fa;
}
.folder-radio-group .el-radio__input {
  margin-right: 6px;
}
.folder-radio-group .folder-radio-item-custom {
  display: flex;
  align-items: center;
  height: 38px;
  padding-left: 18px;
  padding-right: 18px;
  border-radius: 4px;
  border-bottom: 1px solid #ececec;
  position: relative;
  cursor: pointer;
  transition: background 0.2s;
  margin-bottom: 0;
}
.folder-radio-group .folder-radio-item-custom:last-child {
  border-bottom: none;
}
.folder-radio-group .folder-radio-item-custom:hover {
  background: #f5f7fa;
}
.folder-radio-group .custom-radio-circle {
  margin-left: auto;
  /* 保证右侧留白与左侧一致 */
  display: flex;
  align-items: center;
}
.folder-radio-group .circle-outer {
  width: 18px;
  height: 18px;
  border: 2px solid #333;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}
.folder-radio-group .circle-inner {
  width: 10px;
  height: 10px;
  background: #409eff;
  border-radius: 50%;
}
.folder-radio-group .is-checked .circle-outer {
  border-color: #409eff;
}
::v-deep .el-dialog__title {
  font-weight: bold;
}
.top-view-search ::v-deep .el-input__inner {
  height: 30px !important;
}
.dialog-title {
  position: relative;
  display: block;
  width: 100%;
  text-align: center;
}
.dialog-title-text {
  font-weight: bold;
  display: inline-block;
  font-size: 20px;
  color: black;
  max-width: calc(100% - 60px);
  word-break: break-all;
  vertical-align: middle;
}
.custom-close {
  width: 22px;
  height: 22px;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
/* 自定义 Logo 样式 */
.logo-input-row {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: 15px;
}
.logo-circle-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: #1877ff;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
}
.btn-text {
  display: block;
  line-height: 1.2;
  word-break: break-all;
  white-space: pre-line;
}
.logo-circle-btn.active {
  background: #0d5ddb;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(24, 119, 255, 0.4);
}
.logo-circle-btn:hover:not(.active) {
  background: #409eff;
}
.default-btn {
  background: #fff;
  color: #1877ff;
  border: 1px solid #1877ff;
}
.default-btn.active {
  background: #1877ff;
  color: #fff;
  border-color: #1877ff;
}
.default-btn:hover:not(.active) {
  background: #e6f0ff;
}
.custom-input-btn {
  width: auto;
  padding: 0 12px;
  border-radius: 18px;
  min-width: auto;
  font-size: 11px;
}
.logo-text-btn:hover:not(.active) {
  border-color: #1877ff;
  color: #1877ff;
}
.logo-text-input {
  width: 200px;
}
.logo-text-input :deep(.el-input__inner) {
  text-align: center;
  font-weight: bold;
  font-size: 14px;
}
.logo-color-row {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
}
.color-dot {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  color: #fff;
  font-size: 16px;
  transition: all 0.2s;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.color-dot.active {
  transform: scale(1.15);
}
.color-dot.active span {
  display: block;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}
.color-dot span {
  display: none;
}
.logo-agreement-row {
  margin-top: 15px;
  text-align: center;
}
.logo-agreement-row :deep(.el-checkbox__label) {
  font-size: 12px;
  color: #666;
}
.logo-agreement-row :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  background-color: #1877ff;
  border-color: #1877ff;
}

// 红包设置弹窗样式
.red-packet-dialog-content {
  padding: 0;
  max-height: 500px;
  overflow-y: auto;
}
.red-packet-list {
  margin-bottom: 20px;
}
.red-packet-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.red-packet-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.red-packet-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.red-packet-title {
  font-size: 16px;
  font-weight: 600;
  color: #191919;
}
.red-packet-divider {
  height: 1px;
  background: #f0f0f0;
  margin-bottom: 12px;
}
.red-packet-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.red-packet-item {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  line-height: 1.6;
}
.red-packet-item .item-label {
  color: #909399;
  min-width: 140px;
  flex-shrink: 0;
}
.red-packet-item .item-value {
  color: #333;
  flex: 1;
}
.red-packet-item .item-link {
  color: #1877ff;
  cursor: pointer;
  margin-left: 10px;
}
.red-packet-item .item-link:hover {
  text-decoration: underline;
}
.no-red-packet {
  text-align: center;
  padding: 40px 0;
  color: #999;
}
.no-red-packet img {
  width: 120px;
  height: 120px;
  margin-bottom: 20px;
}
.no-red-packet p {
  font-size: 14px;
  color: #666;
}

/* 支付二维码弹窗样式 */
.payment-qrcode-dialog {
  text-align: left;
}
.payment-qrcode-dialog .dialog-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.payment-qrcode-dialog .dialog-title-text {
  font-size: 16px;
  font-weight: 600;
  color: #191919;
}
.payment-qrcode-dialog .custom-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.payment-qrcode-content {
  padding: 10px 0;
}
.payment-qrcode-content .payment-info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.5;
}
.payment-qrcode-content .payment-info-item .info-label {
  color: #333;
  min-width: 70px;
  flex-shrink: 0;
}
.payment-qrcode-content .payment-info-item .info-value {
  color: #333;
  flex: 1;
}
.payment-qrcode-content .payment-info-item .info-value.amount {
  color: #ff983a;
  font-weight: 600;
  font-size: 18px;
}
.payment-qrcode-content .qrcode-section {
  margin-top: 20px;
  text-align: center;
}
.payment-qrcode-content .qrcode-section .wechat-pay-logo {
  margin-bottom: 10px;
}
.payment-qrcode-content .qrcode-section .wechat-pay-logo img {
  width: 120px;
  height: auto;
}
.payment-qrcode-content .qrcode-section img {
  width: 200px;
  height: 200px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}
.payment-qrcode-content .qrcode-section .scan-tip {
  font-size: 12px;
  color: #999;
  margin: 8px 0 0;
}

.add-red-packet-dialog-content {
  padding: 0;
}
.add-red-packet-dialog-content :deep(.el-form-item__content) {
  text-align: left;
}
.add-red-packet-dialog-content :deep(.el-radio-group) {
  text-align: left;
}
.add-red-packet-dialog-content
  :deep(.el-form-item.is-required .el-form-item__label::before) {
  display: none;
}
.red-packet-tips {
  margin-top: 20px;
}
.red-packet-tips .tips-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}
.red-packet-tips .tips-content p {
  font-size: 13px;
  color: #666;
  line-height: 22px;
  margin: 0;
}
.red-packet-tips .tips-content .tips-red {
  color: #f56c6c;
}
.red-packet-tips .tips-content .tips-link {
  color: #1877ff;
  cursor: pointer;
}
.red-packet-tips .tips-content .tips-link:hover {
  text-decoration: underline;
}
.red-packet-total-price {
  margin-top: 20px;
  text-align: right;
}
.red-packet-total-price .price-value {
  font-size: 24px;
  font-weight: bold;
  color: #f56c6c;
}
.red-packet-total-price .price-tip {
  font-size: 12px;
  color: #999;
  margin-left: 5px;
}
</style>

<style>
.dialogClass {
  border-radius: 9px;
  background: #f8f8f8;
  overflow: hidden;
}
.dialogClassShare {
  border-radius: 9px;
  background: #fff;
  overflow: hidden;
}
/* 分享二维码弹窗：限制内容区最大高度，小屏幕时内部滚动 */
.share-qr-dialog .el-dialog__body {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}
.theme-btn-color {
  background: #1877ff;
  color: #fff;
}
.theme-btn-color[disabled] {
  background: #1877ff;
  color: #fff;
  cursor: not-allowed;
}
.theme-btn-color-gzh {
  background: rgba(24, 119, 255, 0.2);
  color: #1877ff;
}
.theme-btn-color-sjdp {
  background: #1877ff;
  color: #fff;
}
.browser-info {
  width: 100%;
  background: #ffffff;
  border: 1px solid #dcdde0;
  border-radius: 8px;
  margin: 10px auto;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;

  .info-left {
    flex: 1;
    text-align: left;
  }

  .info-title {
    font-size: 16px;
    font-weight: bold;
    color: #010100;
    margin-bottom: 10px;
  }

  .info-content {
    font-size: 14px;
    color: #474747;
    line-height: 1.8;
  }

  .offline-btn {
    color: #5255f7;
    font-weight: bold;
    flex-shrink: 0;
  }
}
.hover-underline:hover {
  text-decoration: underline;
}
</style>
